import React, { createContext, useContext, useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import baseurl from "../services/empresa/baseurl";
import { AuthContext } from "./AuthContext";
import Cookies from 'js-cookie'
import { PermissoesContext } from "./PermissoesContext";
import { use } from "react";

export const ApiContext = createContext();
export const ApiContextProvider = ({ children }) => {

  const { Auth, setAuth, setLoadingAuth, EmpresaKey, setEmpresaKey } = useContext(AuthContext)
  const { ListarMenuUsuario } = useContext(PermissoesContext)
  const [staticKey, setKey] = useState("");
  const [Empresa, setEmpresa] = useState();
  const [Empresas, setEmpresas] = useState([]);
  const [Cadastro, setCadastro] = useState("");
  const [Usuarios, setUsuarios] = useState();
  const [AreaUsuario, setAreaUsuario] = useState();
  const [EdicaoUsuario, setEdicaoUsuario] = useState("")
  const [UsuariosConsulta, setUsuariosConsulta] = useState();
  const [CadastroUsuario, setCadastroUsuario] = useState("");
  const [CadastroLinha, setCadastroLinha] = useState("");
  const [Ciclos, setCiclos] = useState();
  const [CiclosConsulta, setCiclosConsulta] = useState();
  const [CadastroCiclo, setCadastroCiclo] = useState("");
  const [EditarCiclo, setEditarCiclo] = useState();
  const [modalEditarCiclo, setModalEditarCiclo] = useState(false);
  const [modalEnviarCiclo, setModalEnviarCiclo] = useState(false);
  const [CicloAtualKey, setCicloAtualKey] = useState("");
  const [Capacidades, setCapacidades] = useState();
  const [CapacidadesConsulta, setCapacidadesConsulta] = useState();
  const [CapacidadesPorArea, setCapacidadesPorArea] = useState();
  const [ArvoreCapacidades, setArvoreCapacidades] = useState();
  const [Categorias, setCategorias] = useState();
  const [CategoriasConsulta, setCategoriasConsulta] = useState();
  const [Fases, setFases] = useState();
  const [Linhas, setLinhas] = useState();
  const [LinhasConsulta, setLinhasConsulta] = useState();
  const [linhaAtendimento, setlinhaAtendimento] = useState([]);
  const [Setores, setSetores] = useState();
  const [SetoresConsulta, setSetoresConsulta] = useState();
  const [Tipos, setTipos] = useState();
  const [TiposConsulta, setTiposConsulta] = useState();
  const [Dashboard, setDashboard] = useState();
  const [DashboardDados, setDashboardDados] = useState();
  const [DashboardFases, setDashboardFases] = useState();
  const [DashboardLinhas, setDashboardLinhas] = useState();
  const [DashboardImpacto, setDashboardImpacto] = useState();
  const [DemandaDadoDash, setDemandaDadoDash] = useState()
  const [DemandaAtualKey, setDemandaAtualKey] = useState("");
  const [AvaliacaoAtualKey, setAvaliacaoAtualKey] = useState("");
  const [FormDemanda, setForm] = useState("");
  const [Demandas, setDemandas] = useState([]);
  const [DemandaAtual, setDemandaAtual] = useState();
  const [modalEditarOpen, setModalEditar] = useState(false);
  const [EditarDemandaModal, setModalEditarDemanda] = useState(false);
  const [alterarGutBSC, setAlterarGutBSC] = useState(false)
  const [ExcluirDemandaModal, setModalExcluirDemanda] = useState(false);
  const [ExcluirCicloModal, setModalExcluirCiclo] = useState(false);
  const [TrocarRoleModal, setModalTrocarRole] = useState(false);
  const [DiretrizEstrategica, setDiretrizEstrategica] = useState();
  const [Prioridades, setPrioridades] = useState();
  const [ResumoPrioridades, setResumoPrioridades] = useState();
  const [Gut, setGut] = useState(0);
  const [GutBSC, setgutBSC] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [modalCriarDemanda, setModalCriarDemanda] = useState(false);
  const [GutGravidade, setGutGravidade] = useState(0);
  const [GutUrgencia, setGutUrgencia] = useState(0);
  const [GutTendencia, setGutTendencia] = useState(0);
  const [BSC, setBSC] = useState(0);
  const [BSCFiltro, setBSCFiltro] = useState(0);
  const [DemandasCiclo, setDemandasCiclo] = useState([]);
  const [FormSelecionarCiclo, setFormSelecionarCiclo] = useState("");
  const [AddComentario, setAddComentario] = useState("");
  const [Comentario, setComentario] = useState();
  const [AddComentarioModal, setAddComentarioModal] = useState(false);
  const [AddLink, setAddLink] = useState("");
  const [AddFile, setAddFile] = useState("");
  const [File, setFile] = useState("");
  const [Link, setLink] = useState();
  const [AddRisco, setAddRisco] = useState("");
  const [Risco, setRisco] = useState();
  const [RiscoEditar, setRiscoEditar] = useState(false)
  const [FiltroDemanda, setFiltroDemanda] = useState('')
  const [Error, setError] = useState("");
  const [Success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [BSCDados, setBSCDados] = useState('')
  const [BSCPorCiclo, setBSCPorCiclo] = useState('')
  const [DiretrizEstrategicaPorCiclo, setDiretrizEstrategicaPorCiclo] = useState('')
  const [PrioridadesPorCiclo, setPrioridadesPorCiclo] = useState('')
  const [ResumoPrioridadesPorCiclo, setResumoPrioridadesPorCiclo] = useState('')
  const [FormLink, setFormLink] = useState([]);
  const [FormComentario, setFormComentario] = useState([]);
  const [FormRisco, setFormRisco] = useState([]);
  const [FormAnexo, setFormAnexo] = useState([]);
  const [UserId, setIdUser] = useState('')
  const [NomeUser, setNomeUser] = useState('')
  const [EmailUser, setEmailUser] = useState('')
  const [AdminUser, setAdminUser] = useState(false)
  const [SupervisorUser, setSupervisorUser] = useState(false)
  const [LeitorUser, setLeitorUser] = useState(false)
  const [show, setShow] = useState(true)
  const comentarioRef = useRef(null);
  const linkRef = useRef(null);
  const descricaoRef = useRef(null);
  const riscoJustificativaRef = useRef(null);
  const mitigacaoJustificativaRef = useRef(null);
  const [arraySelecionarDemandaCiclo, setArraySelecionarDemandaCiclo] = useState([])
  const [Descricao, setDescricao] = useState('')
  const [CenarioAtual, setCenarioAtual] = useState('')
  const [ProblemaCenarioAtual, setProblemaCenarioAtual] = useState('')
  const [Objetivo, setObjetivo] = useState('')
  const [Resultado, setResultado] = useState('')
  const [Necessidade, setNecessidade] = useState('')
  const [Oportunidade, setOportunidade] = useState('')
  const [DataLimite, setDataLimite] = useState('')
  const [Esforco, setEsforco] = useState('')
  const [ExcluirDemandaCicloModal, setExcluirDemandaCicloModal] = useState(false)
  const [demandaCicloAtual, setDemandaCicloAtual] = useState('')
  const [AddDemandaCiclo, setAddDemandaCiclo] = useState(false)
  const [RTFModal, setRTFModal] = useState(false)
  const [CicloDem, setCicloDem] = useState()
  const [Dem, setDem] = useState()
  const [CancelarDemandaModal, setCancelarDemandaModal] = useState(false)
  const [MotivoCancelar, setMotivoCancelar] = useState('')
  const [ConcluirDemandaModal, setConcluirDemandaModal] = useState(false)
  const [Compartilhar, setCompartilhar] = useState('')
  const [CompartilharDemandaModal, setCompartilharDemandaModal] = useState(false)
  const [DemCompartilhada, setDemCompartilhada] = useState()
  const [ListaDemCompartilhada, setListaDemCompartilhada] = useState()
  const [KeyCompartilhar, setKeyCompartilhar] = useState('')
  const [UrlCompartilhar, setUrlCompartilhar] = useState("")
  const [Swot, setSwot] = useState('')
  const [ForcaSwot, setForcaSwot] = useState([])
  const [FraquezaSwot, setFraquezaSwot] = useState([])
  const [OportunidadeSwot, setOportunidadeSwot] = useState([])
  const [AmeacaSwot, setAmeacaSwot] = useState([])
  const [SwotLista, setSwotLista] = useState('')
  const [SwotListaConsulta, setSwotListaConsulta] = useState('')
  const [SwotItemLista, setSwotItemLista] = useState([])
  const [SwotItemSelecionado, setSwotItemSelecionado] = useState('')
  const [SwotAtualKey, setSwotAtualKey] = useState('')
  const [SwotObter, setSwotObter] = useState()
  const [AddSwotItem, setAddSwotItem] = useState()
  const [SwotMatriz, setSwotMatriz] = useState('')
  const [SwotRelatorio, setSwotRelatorio] = useState('')
  const [SwotRelatorioTi, setSwotRelatorioTi] = useState('')
  const [SwotServico, setSwotServico] = useState('')
  const [ForcaSwotServico, setForcaSwotServico] = useState([])
  const [FraquezaSwotServico, setFraquezaSwotServico] = useState([])
  const [OportunidadeSwotServico, setOportunidadeSwotServico] = useState([])
  const [AmeacaSwotServico, setAmeacaSwotServico] = useState([])
  const [SwotServicoLista, setSwotServicoLista] = useState('')
  const [SwotServicoListaConsulta, setSwotServicoListaConsulta] = useState('')
  const [SwotServicoItemLista, setSwotServicoItemLista] = useState([])
  const [SwotServicoItem, setSwotServicoItem] = useState('')
  const [SwotServicoAtualKey, setSwotServicoAtualKey] = useState('')
  const [SwotServicoObter, setSwotServicoObter] = useState()
  const [AddSwotServicoItem, setAddSwotServicoItem] = useState()
  const [SwotServicoMatriz, setSwotServicoMatriz] = useState('')
  const [SwotServicoRelatorio, setSwotServicoRelatorio] = useState('')

  const [delibComite, setDelibComite] = useState(false)
  const [CadastroArea, setCadastroArea] = useState("")
  const [Areas, setAreas] = useState("")
  const [AreasConsulta, setAreasConsulta] = useState("")
  const [AreaItens, setAreaItens] = useState("")
  const [ItensArea, setItensArea] = useState([])
  const [EdicaoArea, setEdicaoArea] = useState("")
  const [AreaAtualKey, setAreaAtualKey] = useState("")
  const [modalEditarArea, setModalEditarArea] = useState(false);
  const [modalExcluirArea, setModalExcluirArea] = useState(false);
  const [AreaPorCiclo, setAreaPorCiclo] = useState([])
  const [CadastroCargo, setCadastroCargo] = useState("")
  const [Cargos, setCargos] = useState("")
  const [CargosConsulta, setCargosConsulta] = useState("")
  const [EdicaoCargo, setEdicaoCargo] = useState("")
  const [CargoAtualKey, setCargoAtualKey] = useState("")
  const [modalEditarCargo, setModalEditarCargo] = useState(false);
  const [modalExcluirCargo, setModalExcluirCargo] = useState(false);
  const [CadastroPessoa, setCadastroPessoa] = useState("")
  const [Pessoas, setPessoas] = useState("")
  const [PessoasConsulta, setPessoasConsulta] = useState("")
  const [PessoasPorCargo, setPessoasPorCargo] = useState("")
  const [EdicaoPessoa, setEdicaoPessoa] = useState("")
  const [PessoaAtualKey, setPessoaAtualKey] = useState("")
  const [modalEditarPessoa, setModalEditarPessoa] = useState(false);
  const [modalExcluirPessoa, setModalExcluirPessoa] = useState(false);
  const [CadastroCompetencia, setCadastroCompetencia] = useState("")
  const [Competencias, setCompetencias] = useState("")
  const [CompetenciasConsulta, setCompetenciasConsulta] = useState("")
  const [EdicaoCompetencia, setEdicaoCompetencia] = useState("")
  const [CompetenciaAtualKey, setCompetenciaAtualKey] = useState("")
  const [modalEditarCompetencia, setModalEditarCompetencia] = useState(false);
  const [modalExcluirCompetencia, setModalExcluirCompetencia] = useState(false);
  const [CadastroSistema, setCadastroSistema] = useState("")
  const [Sistemas, setSistemas] = useState("")
  const [SistemasConsulta, setSistemasConsulta] = useState("")
  const [CapacidadeServico, setCapacidadeServico] = useState("");
  const [EdicaoSistema, setEdicaoSistema] = useState("")
  const [SistemaAtualKey, setSistemaAtualKey] = useState("")
  const [modalEditarSistema, setModalEditarSistema] = useState(false);
  const [modalExcluirSistema, setModalExcluirSistema] = useState(false);
  const [modalExcluirCapacidade, setModalExcluirCapacidade] = useState(false);
  const [forcaItem, setForcaItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });
  const [fraquezaItem, setFraquezaItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });
  const [oportunidadeItem, setOportunidadeItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });
  const [ameacaItem, setAmeacaItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });

  const [forcaServicoItem, setForcaServicoItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });
  const [fraquezaServicoItem, setFraquezaServicoItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });
  const [oportunidadeServicoItem, setOportunidadeServicoItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });
  const [ameacaServicoItem, setAmeacaServicoItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });

  const [forcaItemItem, setForcaItemItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });
  const [fraquezaItemItem, setFraquezaItemItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });
  const [oportunidadeItemItem, setOportunidadeItemItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });
  const [ameacaItemItem, setAmeacaItemItem] = useState({
    capacidadeNegocioDemandaKey: "",
    gravidade: "",
    urgencia: "",
    tendencia: "",
    gut: "",
    tipo: "0"
  });

  const [CicloCadastro, setCicloCadastro] = useState(false);
  const [modalCriarCiclo, setModalCriarCiclo] = useState(false);
  const [modalEditarAvaliacao, setModalEditarAvaliacao] = useState(false);
  const [modalExcluirAvaliacao, setModalExcluirAvaliacao] = useState(false);

  const [SistemaCapacidade, setSistemaCapacidade] = useState("")
  const [CapacidadeAtualKey, setCapacidadeAtualKey] = useState("")
  const [MatrizItem, setMatrizItem] = useState([])

  const [PlanoNegocio, setPlanoNegocio] = useState("")
  const [PlanoNegocios, setPlanoNegocios] = useState()
  const [PlanoNegociosConsulta, setPlanoNegociosConsulta] = useState()
  const [TipoPlanoNegocio, setTipoPlanoNegocio] = useState()
  const [EdicaoPlanoNegocio, setEdicaoPlanoNegocio] = useState("")
  const [PlanoNegocioAtualKey, setPlanoNegocioAtualKey] = useState("")
  const [modalEditarPlanoNegocio, setModalEditarPlanoNegocio] = useState(false);
  const [modalExcluirPlanoNegocio, setModalExcluirPlanoNegocio] = useState(false);

  const [PlanoNegocioAvaliacao, setPlanoNegocioAvaliacao] = useState("")
  const [Avaliacao, setAvaliacao] = useState()
  const [PlanoNegocioAvaliacaoAtualKey, setPlanoNegocioAvaliacaoAtualKey] = useState("")

  const [PlanoDemanda, setPlanoDemanda] = useState()

  const [FormPlano, setFormPlano] = useState([])


  const [DiretrizesItemsDoCiclo, setDiretrizesItemsDoCiclo] = useState([])

  const [stringDiretrizesItems, setStringDiretrizesItems] = useState("")

  const [GutSwot, setGutSwot] = useState(0)
  const [totalGutSwot, setTotalGutSwot] = useState(0);
  const [CapacidadeDemanda, setCapacidadeDemanda] = useState([])
  const [Capacidade, setCapacidade] = useState([])
  const [EdicaoCapacidade, setEdicaoCapacidade] = useState([])

  const [CompetenciaDemanda, setCompetenciaDemanda] = useState([])

  const [BSCs, setBSCs] = useState([])
  const [BSCsConsulta, setBSCsConsulta] = useState([])
  const [CadastroBSC, setCadastroBSC] = useState([])
  const [modalEditarBSC, setModalEditarBSC] = useState(false)
  const [showModalArvoreDeCapacidades, setModalArvoreDeCapacidades] = useState(false)
  const [showModalCustoxdemanda, setModalCustoxdemanda] = useState(false)
  const [SwotPorCiclo, setSwotPorCiclo] = useState([])
  const [SwotServicoPorCiclo, setSwotServicoPorCiclo] = useState([])
  const [DemandaPorCiclo, setDemandaPorCiclo] = useState([])
  const [CapacidadePorAreaSwot, setCapacidadePorAreaSwot] = useState([])
  const [CicloValido, setCicloValido] = useState()

  const [AddCruzamento, setAddCruzamento] = useState()
  const [Cruzamento, setCruzamento] = useState([])

  const [modalExcluirCruzamento, setModalExcluirCruzamento] = useState(false)
  const [cruzamentoKey, setCruzamentoKey] = useState("")
  const [cruzamentoServicoKey, setCruzamentoServicoKey] = useState("")
  const [cruzamentoItemKey, setCruzamentoItemKey] = useState("")

  const [modalBSCPadrao, setModalBSCPadrao] = useState(false)
  const [Permissao, setPermissao] = useState([])

  const [CapacidadeSistema, setCapacidadeSistema] = useState("")
  const [LinhaAtualKey, setLinhaAtualKey] = useState("")


  const dominio = window.location.origin;

  const getEmpresa = () => {
    setEmpresa(Cookies.get("Empresa"));
  }

  const getPermissao = () => {
    const permissaoCookies = Cookies.get("Permissao");
    if (permissaoCookies && permissaoCookies.length > 0) {
      setPermissao(JSON.parse(permissaoCookies));
    }
  }

  const RetornaPermissao = useCallback(async () => {
    const token = Cookies.get("Token");
    try {
      const response = await axios({
        url: baseurl + "Permissoes/RetornaPermissao?empresaKey=" + EmpresaKey,
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        Cookies.set("Permissao", JSON.stringify(response.data));
        setPermissao(response.data);
      } else {
        console.log("Sem dados válidos para permissões");
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  });

  const CadastrarEmpresa = async (event) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    try {
      if (Cadastro === "") {
        setError("Formulário vazio.");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.razaoSocial === "undefined") {
        setError("Razão social não informada");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.fantasia === "undefined") {
        setError("Fantasia não informada");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.cnpj === "undefined") {
        setError("CNPJ não informado");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.telefone === "undefined") {
        setError("Telefone não informado");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.email === "undefined") {
        setError("E-mail não informado");
        setTimeout(() => {
          setError("");
        }, 2000);
        return;
      }
      if (typeof Cadastro.endereco === "undefined") {
        setError("Endereço não informado");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.enderecoNumero === "undefined") {
        setError("Número não informado");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.enderecoBairro === "undefined") {
        setError("Bairro não informado");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.enderecoCidade === "undefined") {
        setError("Cidade não informada");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.enderecoUF === "undefined") {
        setError("Estado não informado");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof Cadastro.enderecoCEP === "undefined") {
        setError("CEP não informado");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
    } catch (error) {
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
    }
    const data = {
      key: Cadastro.key,
      razaoSocial: Cadastro.razaoSocial,
      fantasia: Cadastro.fantasia,
      cnpj: Cadastro.cnpj,
      telefone: Cadastro.telefone,
      emailEmpresa: Cadastro.emailEmpresa,
      emailLogin: Cadastro.emailLogin,
      nome: Cadastro.nome,
      endereco: Cadastro.endereco,
      enderecoNumero: Cadastro.enderecoNumero,
      enderecoBairro: Cadastro.enderecoBairro,
      enderecoCidade: Cadastro.enderecoCidade,
      enderecoUF: Cadastro.enderecoUF,
      enderecoCEP: Cadastro.enderecoCEP,
    };
    return axios({
      url: baseurl + "Empresa/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        setSuccess("Empresa cadastrada com sucesso.");
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
        ListaEmpresas()
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setAuth(false)
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaEmpresas = useCallback(async () => {
    setLoadingAuth(true)
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Empresa/Listar?url=" + window.location.hostname + "&somenteAtivas=S",
      method: "GET",
      timeout: 15000,
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setEmpresas(response.data);
        if (response.data?.length == 1) {
          Cookies.set('Empresa', (response.data.map(item => item.value))[0])
          Cookies.set("Key", (response.data.map(item => item.key))[0])
          setKey((response.data.map(item => item.key))[0])
          setEmpresaKey((response.data.map(item => item.key))[0])
        }
        setLoadingAuth(false)
      })
      .catch((error) => {
        setLoadingAuth(false)
        setLoading(false)
        if (error.response.status === 401) {
          setAuth(false)
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          return
        }
        return Promise.reject(error);
      })

  })

  const CadastrarUsuario = async (currentPage) => {
    const token = Cookies.get("Token");
    setLoading(true);
    if (CadastroUsuario === "") {
      setLoading(false)
      setError("Formulário vazio.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof CadastroUsuario.nome === "undefined") {
      setLoading(false)
      setError("Nome não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof CadastroUsuario.email === "undefined") {
      setLoading(false)
      setError("E-mail não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      EmpresaKey: EmpresaKey,
      nome: CadastroUsuario.nome,
      email: CadastroUsuario.email,
      senha: CadastroUsuario.senha,
      ativo: CadastroUsuario.ativo,
      admin: CadastroUsuario.admin,
      urlOrigem: dominio,
      permissoes: CadastroUsuario.permissoes,
      areas: CadastroUsuario.areas
    };
    return axios({
      url: baseurl + "Autenticacao/CriarUsuario",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaUsuariosConsulta(currentPage, 10)
        setSuccess("Usuário cadastrado com sucesso!");
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaUsuarios = useCallback(async () => {
    let objUsuarios = {};
    let arrayUsuarios = [];
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Empresa/ListarUsuarios?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const user = eval(response.data);
        user.forEach((e) => {
          objUsuarios = {
            nome: e.nome,
            dataCadastro: e.dataCadastro,
            ultimoLogin: e.ultimoLogin,
            ativo: e.ativo,
            admin: e.admin,
            politicaPrivacidadeDataAceite: e.politicaPrivacidadeDataAceite,
            politicaPrivacidadeVersao: e.politicaPrivacidadeVersao,
            id: e.id,
            userName: e.userName,
            normalizedUserName: e.normalizedUserName,
            email: e.email,
            normalizedEmail: e.normalizedEmail,
            emailConfirmed: e.emailConfirmed,
            passwordHash: e.passwordHash,
            securityStamp: e.securityStamp,
            concurrencyStamp: e.concurrencyStamp,
            phoneNumber: e.phoneNumber,
            phoneNumberConfirmed: e.phoneNumberConfirmed,
            twoFactorEnabled: e.twoFactorEnabled,
            lockoutEnd: e.lockoutEnd,
            lockoutEnabled: e.lockoutEnabled,
            accessFailedCount: e.accessFailedCount
          };
          arrayUsuarios.push(objUsuarios);
        });
        setUsuarios(arrayUsuarios);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [totalRegistrosUsuario, setTotalRegistrosUsuario] = useState(0);

  const ListaUsuariosConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "Empresa/ListarUsuariosConsulta?empresaKey=" + `${EmpresaKey}` + "&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        nome: e.nome,
        dataCadastro: e.dataCadastro,
        ultimoLogin: e.ultimoLogin,
        ativo: e.ativo,
        admin: e.admin,
        politicaPrivacidadeDataAceite: e.politicaPrivacidadeDataAceite,
        politicaPrivacidadeVersao: e.politicaPrivacidadeVersao,
        id: e.id,
        userName: e.userName,
        normalizedUserName: e.normalizedUserName,
        email: e.email,
        normalizedEmail: e.normalizedEmail,
        emailConfirmed: e.emailConfirmed,
        passwordHash: e.passwordHash,
        securityStamp: e.securityStamp,
        concurrencyStamp: e.concurrencyStamp,
        phoneNumber: e.phoneNumber,
        phoneNumberConfirmed: e.phoneNumberConfirmed,
        twoFactorEnabled: e.twoFactorEnabled,
        lockoutEnd: e.lockoutEnd,
        lockoutEnabled: e.lockoutEnabled,
        accessFailedCount: e.accessFailedCount
      }));
      setUsuariosConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosUsuario(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const ListaAreaUsuario = useCallback(async (id) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Empresa/ListarAreaUsuario?UsuarioId=" + id + "&empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setAreaUsuario(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        // error.response.data.map((er) => {
        //   setError(`${er.campo}: ${er.mensagem}`)
        // })
        // setTimeout(() => {
        //   setError("");
        // }, 3000);
        return Promise.reject();
      });
  })

  const [AreaUsuarioMapaCalor, setAreaUsuarioMapaCalor] = useState([])

  const ListaAreaUsuarioMapaCalor = useCallback(async () => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/ListarAreaUsuario?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setAreaUsuarioMapaCalor(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [filtroUsuario, setFiltroUsuario] = useState([]);
  const [totalRegistrosFiltroUsuario, setTotalRegistrosFiltroUsuario] = useState(0);

  const ListaFiltroUsuario = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Empresa/ListarUsuariosComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroUsuario(response.data.data);
        setTotalRegistrosFiltroUsuario(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const StatusUsuario = async (id, status, currentPage) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Autenticacao/Ativo?UsuarioId=" + id + "&status=" + status,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        ListaUsuariosConsulta(currentPage, 10)
        if (status) {
          setSuccess("Usuário ativado com sucesso.")
        } else {
          setSuccess("Usuário inativado com sucesso.")
        }
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const CadastrarCiclo = async () => {
    const token = Cookies.get("Token")
    let data = {
      demandaKey: DemandaAtualKey,
      cicloDemandaKey: CadastroCiclo.cicloDemandaKey,
      cicloOrdem: CadastroCiclo.cicloOrdem != '' ? CadastroCiclo.cicloOrdem : 0,
    }
    try {
      if (CadastroCiclo === '') {
        setError("Formulário vazio.");
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      }
      if (!CadastroCiclo.cicloDemandaKey) {
        setError("Ciclo obrigatório.")
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      }
    } catch (error) {
    }
    return axios({
      url: baseurl + "Demanda/AdicionarCiclo",
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      data: data
    })
      .then((response) => {
        ListaDemanda(true, "PRIORIZACAO", 1, 50)
        setAddDemandaCiclo(false)
        setSuccess("Ciclo adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        return Promise.resolve(response.data)
      })
      .catch((error) => {
        setAddDemandaCiclo(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const EditarCiclos = async () => {
    let dataInicialISO = '';
    let dataFinalISO = '';
    const token = Cookies.get("Token");
    setLoading(true)
    if (typeof EditarCiclo.dataInicial != "undefined") {
      dataInicialISO = new Date(EditarCiclo.dataInicial).toISOString();
    }
    if (typeof EditarCiclo.dataFinal != "undefined") {
      dataFinalISO = new Date(EditarCiclo.dataFinal).toISOString();
    }
    const data = {
      empresaKey: EmpresaKey,
      descricao: EditarCiclo.descricao,
      dataInicial: dataInicialISO,
      dataFinal: dataFinalISO,
      observacao: EditarCiclo.observacao,
      naoAlterarBSCSwot: EditarCiclo.naoAlterarBSCSwot,
      naoAlterarBSCSwotServico: EditarCiclo.naoAlterarBSCSwotServico,
      idExterno: EditarCiclo.idExterno,
      empresaKey: EmpresaKey,
    };
    return axios({
      url: baseurl + "CicloDemanda/Alterar?key=" + CicloAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCiclos();
        setSuccess("Ciclo editado com sucesso!");
        setModalEditarCiclo(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaCiclos = useCallback(async () => {
    let arrayCiclos = [];
    let objCiclos = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CicloDemanda/Listar?empresaKey=" + `${EmpresaKey}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const ciclos = eval(response.data);
        ciclos.forEach((e) => {
          objCiclos = {
            id: e.id,
            descricao: e.descricao,
            dataInicial: e.dataInicial,
            dataFinal: e.dataFinal,
            observacao: e.observacao,
            usuarioNome: e.usuario != null ? e.usuario.nome : '-',
            key: e.key,
            ativo: e.ativo,
            naoAlterarBSCSwot: e.naoAlterarBSCSwot,
            naoAlterarBSCSwotServico: e.naoAlterarBSCSwotServico,
            idExterno: e.idExterno,
          };
          arrayCiclos.push(objCiclos);
        });
        setCiclos(arrayCiclos);
        return Promise.resolve()
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [totalRegistrosCiclo, setTotalRegistrosCiclo] = useState(0);

  const ListaCiclosConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "CicloDemanda/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        id: e.id,
        descricao: e.descricao,
        dataInicial: e.dataInicial,
        dataFinal: e.dataFinal,
        observacao: e.observacao,
        usuarioNome: e.usuario != null ? e.usuario.nome : '-',
        key: e.key,
        ativo: e.ativo,
        naoAlterarBSCSwot: e.naoAlterarBSCSwot,
        naoAlterarBSCSwotServico: e.naoAlterarBSCSwotServico,
        idExterno: e.idExterno,
      }));
      setCiclosConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosCiclo(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroCiclo, setFiltroCiclo] = useState([]);
  const [totalRegistrosFiltroCiclo, setTotalRegistrosFiltroCiclo] = useState(0);

  const ListaFiltroCiclo = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CicloDemanda/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroCiclo(response.data.data);
        setTotalRegistrosFiltroCiclo(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ObterCicloValido = useCallback(async (empresaKey) => {
    if (!empresaKey) {
      console.warn("ObterCicloValido: EmpresaKey não definida");
      setLoading(false);
      return null;
    }

    setLoading(true);
    const token = Cookies.get("Token");

    return axios({
      url: baseurl + "CicloDemanda/ObterValido?empresaKey=" + `${empresaKey}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false);
        setCicloValido(response.data);
        return response.data; // ✅ retorna o ciclo
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => setError(""), 3000);
          setAuth(false);
          return;
        }
        error.response?.data?.forEach((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => setError(""), 3000);
        return Promise.reject(error);
      });
  }, [EmpresaKey]);

  const ListaDemandaCiclo = useCallback(async () => {
    let arrayDemandasCiclo = [];
    let objDemandasCiclo = {};
    const token = Cookies.get("Token");
    let data = {
      empresaKey: EmpresaKey,
      linhaAtendimentoId: FormSelecionarCiclo.linhaAtendimentoId,
      setorGerenciaDemandaId: FormSelecionarCiclo.setorGerenciaDemandaId,
      somenteAtrasadas: FormSelecionarCiclo.somenteAtrasadas,
      guT_BSC_Pontuacao_Inicial: FormSelecionarCiclo.guT_BSC_Pontuacao_Inicial,
      guT_BSC_Pontuacao_Final: FormSelecionarCiclo.guT_BSC_Pontuacao_Final,
    };

    return axios({
      url: baseurl + "Demanda/SelecionarDemandasCiclo",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data
    })
      .then((response) => {
        const ciclos = eval(response.data);
        ciclos.forEach((e) => {
          objDemandasCiclo = {
            keyDemandaCiclo: e.key,
            descricao: e.descricao,
            titulo: e.titulo,
            linhaAtendimentoId: e.linhaAtendimentoId,
            linhaAtendimentoDescricao: e.linhaAtendimentoDemanda.descricao,
            setorGerenciaDemandaId: e.setorGerenciaDemandaId,
            setorGerenciaDemandaDescricao: e.setorGerenciaDemanda.descricao,
            guT_BSC_Pontuacao: e.guT_BSC_Pontuacao,
          };
          arrayDemandasCiclo.push(objDemandasCiclo);
        });
        setDemandasCiclo(arrayDemandasCiclo);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [MapaCalor, setMapaCalor] = useState([]);

  const ObterMapaCalor = useCallback(async (areaKey, visao) => {
    setLoading(true);
    const token = Cookies.get("Token");
    try {
      const response = await axios({
        url: `${baseurl}CapacidadeNegocioDemanda/MapaCalor`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        params: {
          empresaKey: EmpresaKey,
          areaKey: areaKey,
          visao: visao
        },
      });
      setMapaCalor(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response?.status === 401) {
        setError("Sua sessão expirou, faça login novamente");
        setTimeout(() => setError(""), 3000);
        setAuth(false);
        return;
      }

      const msg = error.response?.data?.[0]?.mensagem || error.response?.data?.mensagem;

      if (msg?.includes("Nenhuma capacidade de negócio encontrada")) {
        setMapaCalor(null);
        return;
      }

      if (Array.isArray(error.response?.data)) {
        error.response.data.forEach((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
      } else {
        setError("Erro ao carregar o mapa de calor.");
      }

      setTimeout(() => setError(""), 3000);
    } finally {
      setLoading(false);
    }
  }, [EmpresaKey, baseurl, setError, setAuth]);

  const ListaCapacidades = useCallback(async (ativo) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/Listar?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=" + ativo,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setCapacidades(response.data);
      })
      .catch((error) => {
        console.log(error)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [CapacidadeObter, setCapacidadeObter] = useState([]);

  const ObterCapacidade = useCallback(async () => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/ObterKey?key=" + CapacidadeAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setCapacidadeObter(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [AreaCapacidade, setAreaCapacidade] = useState([]);

  const ListaAreaCapacidade = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/ListaArea?empresaKey=" + `${EmpresaKey}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setAreaCapacidade(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [totalRegistrosCapacidade, setTotalRegistrosCapacidade] = useState(0);

  const ListaCapacidadesConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "CapacidadeNegocioDemanda/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=N&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        id: e.id,
        descricao: e.descricao,
        ativo: e.ativo,
        key: e.key,
        capacidadeNegocioDemandaPai: e.capacidadeNegocioDemandaPai == null ? "" : e.capacidadeNegocioDemandaPai,
        titulo: e.titulo,
        nivel: e.nivel,
        relevancia: e.relevancia,
        area: e.area,
        pessoa: e.pessoa,
        arquiteto: e.arquiteto,
        tipoCapacidade: e.tipoCapacidade,
        rodar: e.rodar,
        crescer: e.crescer,
        transformar: e.transformar,
        dominio: e.dominio,
        corHexadecimal: e.corHexadecimal,
        dominioCapacidadeMapaCalor: e.dominioCapacidadeMapaCalor
      }));
      setCapacidadesConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosCapacidade(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroCapacidade, setFiltroCapacidade] = useState([]);
  const [totalRegistrosFiltroCapacidade, setTotalRegistrosFiltroCapacidade] = useState(0);

  const ListaFiltroCapacidade = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroCapacidade(response.data.data);
        setTotalRegistrosFiltroCapacidade(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ExcluirCapacidade = async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/Deletar?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaCapacidadesConsulta(currentPage, 10)
        setSuccess("Capacidade excluída com sucesso!")
        setModalExcluirCapacidade(false)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        setModalExcluirCapacidade(false)
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const ConfirmarExcluirCapacidade = useCallback(async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/ConfirmarDeletar?Key=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        ExcluirCapacidade(key, currentPage)
      })
      .catch((error) => {
        setLoading(false)
        setModalExcluirCapacidade(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ListaCapacidadesPorArea = useCallback(async (ativo, key) => {
    let arrayCapacidades = [];
    let objCapacidades = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/ListarPorArea?empresaKey=" + `${EmpresaKey}` + "&areaKey=" + key + "&somenteAtivas=" + ativo,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const capacities = eval(response.data);
        capacities.forEach((e) => {
          objCapacidades = {
            id: e.id,
            descricao: e.descricao,
            ativo: e.ativo,
            key: e.key,
            capacidadeNegocioDemandaPai: e.capacidadeNegocioDemandaPai == null ? "" : e.capacidadeNegocioDemandaPai,
            titulo: e.titulo,
            nivel: e.nivel,
            relevancia: e.relevancia,
            area: e.area,
            pessoa: e.pessoa,
            arquiteto: e.arquiteto,
          };
          arrayCapacidades.push(objCapacidades);
        });
        setCapacidadesPorArea(arrayCapacidades);
      })
      .catch((error) => {
        console.log(error)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ListaCapacidadePorAreaSwot = useCallback(async (cicloId, areaKey) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/ListarPorArea?empresaKey=" + `${EmpresaKey}` + "&cicloId=" + cicloId + "&areaKey=" + areaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setCapacidadePorAreaSwot(response.data);
      })
      .catch((error) => {
        console.log(error)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [AreaSwot, setAreaSwot] = useState([]);

  const ListaAreaSwot = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/ListaArea?empresaKey=" + `${EmpresaKey}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setAreaSwot(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ListaArvoreCapacidades = useCallback(async (ativo) => {
    setLoading(true)
    let arrayCapacidades = [];
    let objCapacidades = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/Arvore?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=" + ativo,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const capacities = eval(response.data);
        capacities.forEach((e) => {
          objCapacidades = {
            id: e.id,
            descricao: e.descricao,
            filhos: e.filhos,
            key: e.key,
            titulo: e.titulo,
            nivel: e.nivel
          };
          arrayCapacidades.push(objCapacidades);
        });
        setArvoreCapacidades(arrayCapacidades);
      })
      .catch((error) => {
        setLoading(false)
        console.log(error)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ListaCategorizacao = useCallback(async (ativo) => {
    let arrayCategorias = [];
    let objCategorias = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CategorizacaoEstrategicaDemanda/Listar?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=" + ativo,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const categories = eval(response.data);
        categories.forEach((e) => {
          objCategorias = {
            id: e.id,
            descricao: e.descricao,
            ativo: e.ativo,
            key: e.key,
            idExterno: e.idExterno,
          };
          arrayCategorias.push(objCategorias);
        });
        setCategorias(arrayCategorias);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [totalRegistrosCategorizacao, setTotalRegistrosCategorizacao] = useState(0);

  const ListaCategorizacaoConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "CategorizacaoEstrategicaDemanda/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=N&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        id: e.id,
        descricao: e.descricao,
        ativo: e.ativo,
        key: e.key,
        idExterno: e.idExterno
      }));
      setCategoriasConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosCategorizacao(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroCategorizacao, setFiltroCategorizacao] = useState([]);
  const [totalRegistrosFiltroCategorizacao, setTotalRegistrosFiltroCategorizacao] = useState(0);

  const ListaFiltroCategorizacao = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CategorizacaoEstrategicaDemanda/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroCategorizacao(response.data.data);
        setTotalRegistrosFiltroCategorizacao(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ListaFases = useCallback(async () => {
    let arrayFases = [];
    let objFases = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "FasesDemanda/Listar?empresaKey=" + `${EmpresaKey}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const phases = eval(response.data);
        phases.forEach((e) => {
          objFases = {
            id: e.id,
            descricao: e.descricao,
            ativo: e.ativo,
            key: e.key,
          };
          arrayFases.push(objFases);
        });
        setFases(arrayFases);
        return Promise.resolve(arrayFases)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setAuth(false)
          return
        }
        // error.response.data.map((er) => {
        //   setError(`${er.campo}: ${er.mensagem}`)
        // })
        console.log(error)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ListaLinhaAtendimento = useCallback(async (ativo) => {
    let arrayLinhas = [];
    let objLinhas = {};
    const token = Cookies.get("Token");
    return axios({
      url:
        baseurl +
        "LinhaAtendimentoDemanda/Listar?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=" + ativo,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const lines = eval(response.data);
        lines.forEach((e) => {
          objLinhas = {
            id: e.id,
            descricao: e.descricao,
            nome: e.nome,
            ativo: e.ativo,
            key: e.key,
            responsavelId: e.responsavelId,
            responsavel: e.responsavel == null ? '' : e.responsavel.nome,
            verTodasLinhas: e.verTodasLinhas,
            idExterno: e.idExterno,
          };
          arrayLinhas.push(objLinhas);
        });
        setLinhas(arrayLinhas);
        return Promise.resolve(arrayLinhas)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [totalRegistrosLinhaAtendimento, setTotalRegistrosLinhaAtendimento] = useState(0);

  const ListaLinhaAtendimentoConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "LinhaAtendimentoDemanda/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=N&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        id: e.id,
        nome: e.nome,
        descricao: e.descricao,
        ativo: e.ativo,
        key: e.key,
        responsavelId: e.responsavelId,
        responsavel: e.responsavel,
        verTodasLinhas: e.verTodasLinhas,
        idExterno: e.idExterno,
      }));
      setLinhasConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosLinhaAtendimento(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroLinhaAtendimento, setFiltroLinhaAtendimento] = useState([]);
  const [totalRegistrosFiltroLinhaAtendimento, setTotalRegistrosFiltroLinhaAtendimento] = useState(0);

  const ListaFiltroLinhaAtendimento = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "LinhaAtendimentoDemanda/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroLinhaAtendimento(response.data.data);
        setTotalRegistrosFiltroLinhaAtendimento(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const [TimeObter, setTimeObter] = useState()

  const ObterTimes = useCallback(async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "LinhaAtendimentoDemanda/ObterKey?key=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setTimeObter(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const [LinhaArea, setLinhaArea] = useState()

  const ListaAreaLinha = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "LinhaAtendimentoDemanda/ListarArea?linhaKey=" + LinhaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLinhaArea(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [ItensLinha, setItensLinha] = useState([])

  const AdicionarLinha = async (nome, descricao, status, responsavelKey, currentPage) => {
    const token = Cookies.get("Token");
    let dados = {
      empresaKey: EmpresaKey,
      descricao: descricao,
      nome: nome,
      responsavelKey: responsavelKey,
      areas: CadastroLinha.areas,
      itens: ItensLinha,
      ativo: status,
      idExterno: CadastroLinha.idExterno,
    };
    return axios({
      url: baseurl + "LinhaAtendimentoDemanda/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: dados,
    })
      .then(() => {
        ListaLinhaAtendimentoConsulta(currentPage, 10)
        setItensLinha([])
        setSuccess("Linha de atendimento adicionada com sucesso!");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const AdicionarLinhaPessoa = async (pessoaKey, cargoKey) => {
    const token = Cookies.get("Token");
    setLoading(true);
    if (cargoKey && !pessoaKey) {
      setLoading(false)
      setError("Pessoa não informada.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    } else if (pessoaKey && !cargoKey) {
      setLoading(false)
      setError("Cargo não informado.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      linhaAtendimentoDemandaKey: LinhaAtualKey,
      pessoaKey: pessoaKey,
      cargoKey: cargoKey
    };
    return axios({
      url: baseurl + "LinhaAtendimentoDemanda/AdicionarItem",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaLinhaPessoas()
        setSuccess("Item adicionado com sucesso!");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaLinhaPessoas = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "LinhaAtendimentoDemanda/ListarItem?linhaKey=" + LinhaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setItensLinha(response.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const ExcluirLinhaPessoa = async (key) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "LinhaAtendimentoDemanda/ExcluirItem?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaLinhaPessoas()
        setSuccess("Item excluído com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const [EdicaoLinha, setEdicaoLinha] = useState()

  const EditarLinha = async (nome, descricao, status, responsavelId, currentPage) => {
    const token = Cookies.get("Token");
    let dados = {
      empresaKey: EmpresaKey,
      nome: nome,
      descricao: descricao,
      ativo: status,
      responsavelKey: responsavelId,
      areas: EdicaoLinha.areas,
      empresaKey: EmpresaKey,
    };
    return axios({
      url: baseurl + "LinhaAtendimentoDemanda/Alterar?key=" + LinhaAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: dados,
    })
      .then(() => {
        ListaLinhaAtendimentoConsulta(currentPage, 10)
        ListaUsuarios()
        setSuccess("Linha de Atendimento alterada com sucesso.")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaSetorGerencia = useCallback(async (ativo) => {
    let arraySetores = [];
    let objSetores = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "SetorGerenciaDemanda/Listar?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=" + ativo,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const sectors = eval(response.data);
        sectors.forEach((e) => {
          objSetores = {
            id: e.id,
            descricao: e.descricao,
            ativo: e.ativo,
            key: e.key,
          };
          arraySetores.push(objSetores);
        });
        setSetores(arraySetores);
        return Promise.resolve()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [totalRegistrosSetorGerencia, setTotalRegistrosSetorGerencia] = useState(0);

  const ListaSetorGerenciaConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "SetorGerenciaDemanda/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=N&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        id: e.id,
        descricao: e.descricao,
        ativo: e.ativo,
        key: e.key,
      }));
      setSetoresConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosSetorGerencia(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroSetorGerencia, setFiltroSetorGerencia] = useState([]);
  const [totalRegistrosFiltroSetorGerencia, setTotalRegistrosFiltroSetorGerencia] = useState(0);

  const ListaFiltroSetorGerencia = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "SetorGerenciaDemanda/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroSetorGerencia(response.data.data);
        setTotalRegistrosFiltroSetorGerencia(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ListaTipoDemanda = useCallback(async (ativo) => {
    let arrayTipos = [];
    let objTipos = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "TipoDemanda/Listar?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=" + ativo,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const types = eval(response.data);
        types.forEach((e) => {
          objTipos = {
            id: e.id,
            descricao: e.descricao,
            ativo: e.ativo,
            key: e.key,
          };
          arrayTipos.push(objTipos);
        });
        setTipos(arrayTipos);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [totalRegistrosTipoDemanda, setTotalRegistrosTipoDemanda] = useState(0);

  const ListaTipoDemandaConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "TipoDemanda/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=N&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        id: e.id,
        descricao: e.descricao,
        ativo: e.ativo,
        key: e.key,
      }));
      setTiposConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosTipoDemanda(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroTipoDemanda, setFiltroTipoDemanda] = useState([]);
  const [totalRegistrosFiltroTipoDemanda, setTotalRegistrosFiltroTipoDemanda] = useState(0);

  const ListaFiltroTipoDemanda = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "TipoDemanda/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroTipoDemanda(response.data.data);
        setTotalRegistrosFiltroTipoDemanda(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ListaDashboard = useCallback(async () => {
    let arrayDashLinhas = [];
    let objDashLinhas = {};
    const token = Cookies.get("Token");
    setLoading(true);
    if (EmpresaKey == "" || typeof EmpresaKey == 'undefined') {
      setLoading(false)
      return
    }
    return axios({
      url: baseurl + "Empresa/Dashboard?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      setLoading(false)
      arrayDashLinhas = []
      const dashboard = eval(response.data);
      const dashboardFases = eval(response.data.demandaFaseDados)
      const dashboardLinhas = eval(response.data.demandaLinhasDados)
      const dashboardImpacto = eval(response.data.demandaImpactos)
      const demandaDados = eval(response.data.demandaDados)
      let demandaDadosArray = []
      demandaDadosArray.push(demandaDados)
      let count = 1;
      dashboardLinhas.forEach((item) => {
        objDashLinhas = {
          letra: count++,
          descricao: item.descricao,
          quantidade: item.quantidade,
          percentual: item.percentual,
          id: item.id,
          responsavel: item.responsavel
        };
        arrayDashLinhas.push(objDashLinhas)
      })
      setDashboardDados(dashboard);
      setDashboardFases(dashboardFases);
      setDashboardLinhas(arrayDashLinhas);
      setDashboardImpacto(dashboardImpacto)
      setDemandaDadoDash(demandaDadosArray)
      setLoading(false);
      return Promise.resolve([demandaDadosArray, arrayDashLinhas, dashboardFases])
    })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        setError(error.response.data)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }, [EmpresaKey])

  const CriarDemanda = async (priorizacao) => {
    setLoading(true)
    const token = Cookies.get("Token");
    let dataEntregaISO = '';
    let dataLimiteISO = '';

    if (typeof FormDemanda.expectativaEntrega != "undefined" && FormDemanda.expectativaEntrega != "") {
      dataEntregaISO = new Date(FormDemanda.expectativaEntrega).toISOString();
    }
    if (typeof FormDemanda.dataLimite != "undefined" && FormDemanda.dataLimite != "") {
      dataLimiteISO = new Date(FormDemanda.dataLimite).toISOString();
    }
    if (FormDemanda.cicloDemandaId === 0 || typeof FormDemanda.cicloDemandaId === "undefined") {
      setLoading(false)
      setError("Campo ciclo obrigatório, na aba Visão Geral.")
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      titulo: FormDemanda.titulo,
      descricao: FormDemanda.descricao,
      cenarioAtual: FormDemanda.cenarioAtual,
      problemaIdentificadoCenarioAtual: FormDemanda.problemaIdentificadoCenarioAtual,
      objetivo: FormDemanda.objetivo,
      resultadoEsperado: FormDemanda.resultadoEsperado,
      necessidadeNegocio: FormDemanda.necessidadeNegocio,
      oportunidade: FormDemanda.oportunidade,
      prazoRetornoEsperado: FormDemanda.prazoRetornoEsperado,
      faseDemandaId: parseInt(FormDemanda.faseDemandaId, 10) || 0,
      mitigacaoRisco: FormDemanda.mitigacaoRisco,
      mitigacaoRiscoJustificativa: FormDemanda.mitigacaoRiscoJustificativa,
      expectativaEntrega: dataEntregaISO,
      dataLimite: dataLimiteISO,
      justificativaDataLimite: FormDemanda.justificativaDataLimite,
      setorGerenciaDemandaId: parseInt(FormDemanda.setorGerenciaDemandaId),
      solicitante: FormDemanda.solicitante,
      tipoDemandaId: parseInt(FormDemanda.tipoDemandaId),
      classificacaoDemanda: FormDemanda.classificacaoDemanda,
      linhaAtendimentoId: parseInt(FormDemanda.linhaAtendimentoId),
      deliberacaoComite: delibComite,
      esforcoTotal: FormDemanda.esforcoTotal,
      justificativaEsforcoTotal: FormDemanda.justificativaEsforcoTotal,
      categorizacaoEstrategicaDemandaId: parseInt(
        FormDemanda.categorizacaoEstrategicaDemandaId
      ),
      capacidadeNegocioDemandaId: parseInt(
        FormDemanda.capacidadeNegocioDemandaId
      ),
      diretrizEstrategicaId: typeof FormDemanda.diretrizEstrategicaId === "undefined" ? "" : JSON.parse(FormDemanda.diretrizEstrategicaId).id,
      guT_Gravidade: FormDemanda.guT_Gravidade,
      guT_Urgencia: FormDemanda.guT_Urgencia,
      guT_Tendencia: FormDemanda.guT_Tendencia,
      guT_Pontuacao: Gut,
      guT_BSC_Pontuacao: parseFloat(GutBSC),
      guT_Swot: totalGutSwot,
      valor: FormDemanda.valor,
      recursosHumanosInternosQuantidade: FormDemanda.recursosHumanosInternosQuantidade,
      recursosHumanosInternosCompetencias: FormDemanda.recursosHumanosInternosCompetencias,
      recursosHumanosExternosCusto: FormDemanda.recursosHumanosExternosCusto,
      recursosHumanosExternosHospedagem: FormDemanda.recursosHumanosExternosHospedagem,
      recursosHumanosExternosAlimentacao: FormDemanda.recursosHumanosExternosAlimentacao,
      recursosHumanosExternosLocomocao: FormDemanda.recursosHumanosExternosLocomocao,
      recursosHumanosExternosTempo: FormDemanda.recursosHumanosExternosTempo,
      recursosHumanosExternosTipoAtendimento: FormDemanda.recursosHumanosExternosTipoAtendimento,
      infraestruturaNecessariaExecucao: FormDemanda.infraestruturaNecessariaExecucao,
      anoBaseOrcamento: FormDemanda.anoBaseOrcamento,
      comentarios: FormComentario,
      links: FormLink,
      riscos: FormRisco,
      planoNegocio: FormPlano,
      cicloDemandaId: FormDemanda.cicloDemandaId,
      areaId: parseInt(FormDemanda.areaId),
      diretrizesItensBSC: stringDiretrizesItems,
      demandaDependenteId: parseInt(FormDemanda.demandaDependenteId),
      capacidades: FormDemanda.capacidades,
      competencias: FormDemanda.competencias,
      anexo: FormAnexo,
      idExterno: FormDemanda.idExterno
    };
    return axios({
      url: baseurl + "Demanda/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        setLoading(false);
        setSuccess("Demanda adicionada com sucesso.");
        setModalCriarDemanda(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        ListaDemanda(true, priorizacao, 1, 50)
        setForm({})
        setDescricao('')
        setCenarioAtual('')
        setProblemaCenarioAtual('')
        setObjetivo('')
        setResultado('')
        setNecessidade('')
        setOportunidade('')
        setDataLimite('')
        setEsforco('')
        setTotalGutSwot(0)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaDemanda = useCallback(async (filtrar, priorizacao, posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      let data = {}
      if (filtrar) {
        data = {
          empresaKey: EmpresaKey || '',
          areaId: FiltroDemanda.areaId || 0,
          linhaAtendimentoId: FiltroDemanda.linhaAtendimentoId || 0,
          setorGerenciaDemandaId: FiltroDemanda.setorGerenciaDemandaId || 0,
          cicloId: FiltroDemanda.cicloId || 0,
          somenteAtrasadas: FiltroDemanda.somenteAtrasadas,
          guT_BSC_Pontuacao_Inicial: parseFloat(FiltroDemanda.guT_BSC_Pontuacao_Inicial) || 0,
          guT_BSC_Pontuacao_Final: parseFloat(FiltroDemanda.guT_BSC_Pontuacao_Final) || 0,
          faseId: FiltroDemanda.faseId || 0,
          numero: FiltroDemanda.numero || 0,
          somenteSemCiclo: FiltroDemanda.somenteSemCiclo,
          faseDemanda: priorizacao,
          somenteCanceladas: FiltroDemanda.somenteCanceladas,
          somenteConcluidas: FiltroDemanda.somenteConcluidas,
          descricao: FiltroDemanda.descricao,
          pagina: posicao,
          paginaQuantidadeRegistros: qtd
        }
      }
      else {
        data = {
          empresaKey: EmpresaKey,
          areaId: 0,
          linhaAtendimentoId: 0,
          setorGerenciaDemandaId: 0,
          cicloId: 0,
          somenteAtrasadas: false,
          guT_BSC_Pontuacao_Inicial: 0,
          guT_BSC_Pontuacao_Final: 0,
          faseId: 0,
          numero: 0,
          somenteSemCiclo: false,
          faseDemanda: priorizacao,
          somenteCanceladas: false,
          somenteConcluidas: false,
          descricao: '',
          pagina: posicao,
          paginaQuantidadeRegistros: qtd
        }
      }
      const response = await axios({
        url: baseurl + "Demanda/ListarTodasDaEmpresa",
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        data: data
      });
      setLoading(false);
      const user = eval(response.data);
      const arrayCapacidades = user.map((e) => ({
        chave: e.key,
        id: e.id,
        titulo: e.titulo,
        criacaoDataHora: e.criacaoDataHora,
        criacaoUsuarioNome: e.criacaoUsuarioNome,
        descricao: e.descricao,
        faseDemandaId: e.faseDemandaId,
        faseDescricao: e.faseDescricao,
        expectativaEntrega: e.expectativaEntrega,
        dataLimite: e.dataLimite,
        setorGerenciaDescricao: e.setorGerenciaDescricao,
        solicitante: e.solicitante,
        tipoDescricao: e.tipoDescricao,
        linhaAtendimentoId: e.linhaAtendimentoId,
        linhaAtendimentoDescricao: e.linhaAtendimentoDescricao,
        diretrizEstrategicaDescricao: e.diretrizEstrategicaDescricao,
        diretrizEstrategicaId: e.diretrizEstrategicaId,
        pesoBSC: e.pesoBSC,
        guT_Gravidade: e.guT_Gravidade,
        guT_Urgencia: e.guT_Urgencia,
        guT_Tendencia: e.guT_Tendencia,
        guT_Pontuacao: e.guT_Pontuacao,
        guT_BSC_Pontuacao: e.guT_BSC_Pontuacao,
        guT_Swot: e.guT_Swot,
        esforcoTotal: parseInt(e.esforcoTotal),
        cancelamentoDataHora: e.cancelamentoDataHora,
        conclusaoDataHora: e.conclusaoDataHora,
        cicloOrdem: e.cicloOrdem,
        cicloDescricao: e.cicloDescricao,
        areaId: e.areaId,
        areaDescricao: e.areaDescricao,
        idExterno: e.idExterno
      }));
      setDemandas(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const ObterDemanda = useCallback(async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ObterKey?key=" + key,
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const dem = response.data;
        const objDemandas = {
          empresaId: dem.empresaId,
          empresa: dem.empresa,
          titulo: dem.titulo,
          descricao: dem.descricao,
          cenarioAtual: dem.cenarioAtual,
          problemaIdentificadoCenarioAtual: dem.problemaIdentificadoCenarioAtual,
          objetivo: dem.objetivo,
          resultadoEsperado: dem.resultadoEsperado,
          necessidadeNegocio: dem.necessidadeNegocio,
          oportunidade: dem.oportunidade,
          prazoRetornoEsperado: dem.prazoRetornoEsperado,
          faseDemandaId: dem.faseDemandaId,
          faseDemanda: dem.faseDemanda,
          expectativaEntrega: dem.expectativaEntrega,
          dataLimite: dem.dataLimite,
          justificativaDataLimite: dem.justificativaDataLimite,
          setorGerenciaDemandaId: dem.setorGerenciaDemandaId,
          setorGerenciaDemanda: dem.setorGerenciaDemanda,
          solicitante: dem.solicitante,
          tipoDemandaId: dem.tipoDemandaId,
          tipoDemanda: dem.tipoDemanda,
          classificacaoDemanda: dem.classificacaoDemanda,
          linhaAtendimentoId: dem.linhaAtendimentoId,
          linhaAtendimentoDemanda: dem.linhaAtendimentoDemanda,
          deliberacaoComite: dem.deliberacaoComite,
          esforcoTotal: dem.esforcoTotal,
          justificativaEsforcoTotal: dem.justificativaEsforcoTotal,
          categorizacaoEstrategicaDemandaId: dem.categorizacaoEstrategicaDemandaId,
          categorizacaoEstrategicaDemanda: dem.categorizacaoEstrategicaDemanda,
          capacidadeNegocioDemandaId: dem.capacidadeNegocioDemandaId,
          capacidadeNegocioDemanda: dem.capacidadeNegocioDemanda,
          diretrizEstrategicaId: dem.diretrizEstrategicaId,
          diretrizEstrategica: dem.diretrizEstrategica,
          guT_Gravidade: dem.guT_Gravidade,
          guT_Urgencia: dem.guT_Urgencia,
          guT_Tendencia: dem.guT_Tendencia,
          guT_Pontuacao: dem.guT_Pontuacao,
          guT_BSC_Pontuacao: dem.guT_BSC_Pontuacao,
          guT_Swot: dem.guT_Swot,
          aprovacaoUsuarioId: dem.aprovacaoUsuarioId,
          aprovacaoDataHora: dem.aprovacaoDataHora,
          usuarioAprovacao: dem.usuarioAprovacao,
          cicloDemandaId: dem.cicloDemandaId,
          cicloDemanda: dem.cicloDemanda,
          cicloDemandaOrdem: dem.cicloDemandaOrdem,
          criacaoUsuarioId: dem.criacaoUsuarioId,
          criacaoDataHora: dem.criacaoDataHora,
          usuarioCriacao: dem.usuarioCriacao,
          alteracaoDataHora: dem.alteracaoDataHora,
          cancelamentoDataHora: dem.cancelamentoDataHora,
          conclusaoDataHora: dem.conclusaoDataHora,
          valor: dem.valor,
          recursosHumanosInternosQuantidade: dem.recursosHumanosInternosQuantidade,
          recursosHumanosInternosCompetencias: dem.recursosHumanosInternosCompetencias,
          recursosHumanosExternosCusto: dem.recursosHumanosExternosCusto,
          recursosHumanosExternosHospedagem: dem.recursosHumanosExternosHospedagem,
          recursosHumanosExternosAlimentacao: dem.recursosHumanosExternosAlimentacao,
          recursosHumanosExternosLocomocao: dem.recursosHumanosExternosLocomocao,
          recursosHumanosExternosTempo: dem.recursosHumanosExternosTempo,
          recursosHumanosExternosTipoAtendimento: dem.recursosHumanosExternosTipoAtendimento,
          infraestruturaNecessariaExecucao: dem.infraestruturaNecessariaExecucao,
          anoBaseOrcamento: dem.anoBaseOrcamento,
          id: dem.id,
          key: dem.key,
          podeVerValores: dem.podeVerValores,
          areaId: dem.areaId,
          diretrizesItensBSC: dem.diretrizesItensBSC,
          area: dem.area,
          demandaDependenteId: dem.demandaDependenteId,
          idExterno: dem.idExterno,
        }
        setDem(objDemandas);
        return Promise.resolve()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        return Promise.reject()
      })
  })

  const EditarDemanda = async (priorizacao) => {
    let dataEntregaISO = '';
    let dataLimiteISO = '';
    const token = Cookies.get("Token");
    try {
      if (Dem?.expectativaEntrega) {
        dataEntregaISO = new Date(Dem.expectativaEntrega).toISOString();
      }
      if (Dem?.dataLimite) {
        dataLimiteISO = new Date(Dem.dataLimite).toISOString();
      }
      if (Dem.esforcoTotal < 0) {
        setError("Esforço total não pode ser negativo.");
        setTimeout(() => {
          setError("");
        }, 3000);
        setLoading(false);
        return;
      }
    } catch (error) {
    }
    const data = {
      empresaKey: EmpresaKey,
      titulo: Dem.titulo,
      descricao: Dem.descricao,
      cenarioAtual: Dem.cenarioAtual,
      problemaIdentificadoCenarioAtual: Dem.problemaIdentificadoCenarioAtual,
      objetivo: Dem.objetivo,
      resultadoEsperado: Dem.resultadoEsperado,
      necessidadeNegocio: Dem.necessidadeNegocio,
      oportunidade: Dem.oportunidade,
      prazoRetornoEsperado: Dem.prazoRetornoEsperado,
      faseDemandaId: JSON.parse(Dem.faseDemandaId).id ? JSON.parse(Dem.faseDemandaId).id : Dem.faseDemandaId,
      riscoAtual: Dem.riscoAtual,
      riscoAtualJustificativa: Dem.riscoAtualJustificativa,
      mitigacaoRisco: Dem.mitigacaoRisco,
      mitigacaoRiscoJustificativa: Dem.mitigacaoRiscoJustificativa,
      expectativaEntrega: dataEntregaISO,
      dataLimite: dataLimiteISO,
      justificativaDataLimite: Dem.justificativaDataLimite,
      setorGerenciaDemandaId: Dem.setorGerenciaDemandaId ? parseInt(Dem.setorGerenciaDemandaId) : 0,
      solicitante: Dem.solicitante,
      tipoDemandaId: parseInt(Dem.tipoDemandaId),
      classificacaoDemanda: Dem.classificacaoDemanda,
      linhaAtendimentoId: Dem.linhaAtendimentoId ? parseInt(Dem.linhaAtendimentoId) : Dem.linhaAtendimentoId,
      deliberacaoComite: eval(Dem.deliberacaoComite),
      esforcoTotal: Dem.esforcoTotal,
      justificativaEsforcoTotal: Dem.justificativaEsforcoTotal,
      categorizacaoEstrategicaDemandaId: parseInt(
        Dem.categorizacaoEstrategicaDemandaId
      ),
      capacidadeNegocioDemandaId: parseInt(
        Dem.capacidadeNegocioDemandaId
      ),
      diretrizEstrategicaId: Dem.diretrizEstrategicaId,
      guT_Gravidade: Dem.guT_Gravidade,
      guT_Urgencia: Dem.guT_Urgencia,
      guT_Tendencia: Dem.guT_Tendencia,
      guT_Pontuacao: Dem.guT_Pontuacao,
      guT_BSC_Pontuacao: Dem.guT_BSC_Pontuacao,
      guT_Swot: Dem.guT_Swot,
      valor: Dem.valor,
      recursosHumanosInternosQuantidade: Dem.recursosHumanosInternosQuantidade,
      recursosHumanosInternosCompetencias: Dem.recursosHumanosInternosCompetencias,
      recursosHumanosExternosCusto: Dem.recursosHumanosExternosCusto,
      recursosHumanosExternosHospedagem: Dem.recursosHumanosExternosHospedagem,
      recursosHumanosExternosAlimentacao: Dem.recursosHumanosExternosAlimentacao,
      recursosHumanosExternosLocomocao: Dem.recursosHumanosExternosLocomocao,
      recursosHumanosExternosTempo: Dem.recursosHumanosExternosTempo,
      recursosHumanosExternosTipoAtendimento: Dem.recursosHumanosExternosTipoAtendimento,
      infraestruturaNecessariaExecucao: Dem.infraestruturaNecessariaExecucao,
      anoBaseOrcamento: Dem.anoBaseOrcamento,
      planoNegocio: Dem.planoNegocio,
      areaId: Dem.areaId ? parseInt(Dem.areaId) : 0,
      cicloDemandaId: Dem.cicloDemandaId ? parseInt(Dem.cicloDemandaId) : 0,
      diretrizesItensBSC: Dem.diretrizesItensBSC,
      demandaDependenteId: Dem.demandaDependenteId,
      idExterno: Dem.idExterno,
      empresaKey: EmpresaKey,
    };
    return axios({
      url: baseurl + "Demanda/Alterar?key=" + DemandaAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaDemanda(true, priorizacao, 1, 50);
        setSuccess("Demanda editada com sucesso!");
        setModalEditarDemanda(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setDescricao('')
        setCenarioAtual('')
        setProblemaCenarioAtual('')
        setObjetivo('')
        setResultado('')
        setNecessidade('')
        setOportunidade('')
        setDataLimite('')
        setEsforco('')
        setGutSwot(0)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirDemanda = async () => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/Excluir?key=" + DemandaAtualKey,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaDemanda(true, '', 1, 50);
        setSuccess("Demanda excluída com sucesso!");
        setModalExcluirDemanda(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const [AreaDemanda, setAreaDemanda] = useState([]);

  const ListaAreaDemanda = useCallback(async (ativo) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ListaArea" + "?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setAreaDemanda(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const AdicionarCapacidade = async (event, currentPage, capacidadeNegocioPaiKey, dominio) => {
    setLoading(true)
    event.preventDefault();
    const token = Cookies.get("Token");
    let dados = {
      empresaKey: EmpresaKey,
      descricao: Capacidade.descricao,
      ativo: true,
      capacidadeNegocioPaiKey: capacidadeNegocioPaiKey,
      titulo: Capacidade.titulo,
      nivel: Capacidade.nivel,
      relevancia: Capacidade.relevancia,
      areaKey: Capacidade.areaKey,
      pessoaKey: Capacidade.pessoaKey,
      arquitetoKey: Capacidade.arquitetoKey,
      servicos: Capacidade.servicos,
      tipoCapacidade: Capacidade.tipoCapacidade,
      rodar: Capacidade.rodar,
      crescer: Capacidade.crescer,
      transformar: Capacidade.transformar,
      dominio: dominio,
      corHexadecimal: Capacidade.corHexadecimal,
      dominioCapacidadeMapaCalorKey: Capacidade.dominioCapacidadeMapaCalorKey
    };
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: dados,
    })
      .then(() => {
        setLoading(false)
        ListaCapacidadesConsulta(currentPage, 10)
        ListaArvoreCapacidades()
        setSuccess("Capacidade de Negócio adicionada com sucesso!");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        console.log(error)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const EditarCapacidade = async (key, keyPai, areaKey, pessoaKey, arquitetoKey, currentPage, dominio, dominioKey) => {
    const token = Cookies.get("Token");
    const data = {
      empresaKey: EmpresaKey,
      descricao: EdicaoCapacidade.descricao,
      ativo: EdicaoCapacidade.ativo,
      capacidadeNegocioPaiKey: keyPai,
      titulo: EdicaoCapacidade.titulo,
      nivel: EdicaoCapacidade.nivel,
      relevancia: EdicaoCapacidade.relevancia,
      areaKey: areaKey,
      pessoaKey: pessoaKey,
      arquitetoKey: arquitetoKey,
      servicos: EdicaoCapacidade.servicos,
      empresaKey: EmpresaKey,
      tipoCapacidade: EdicaoCapacidade.tipoCapacidade,
      rodar: EdicaoCapacidade.rodar,
      crescer: EdicaoCapacidade.crescer,
      transformar: EdicaoCapacidade.transformar,
      dominio: dominio,
      corHexadecimal: EdicaoCapacidade.corHexadecimal,
      dominioCapacidadeMapaCalorKey: dominioKey
    };
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/Alterar?Key=" + key,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCapacidadesConsulta(currentPage, 10);
        setSuccess("Capacidade de Negócio editada com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const [TipoCapacidade, setTipoCapacidade] = useState([]);

  const RetornaTipoCapacidade = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/RetornaTipoCapacidade",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setTipoCapacidade(response.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }, []);

  const AdicionarServicoCapacidade = async (key) => {
    const token = Cookies.get("Token");
    const data = {
      servicoKey: key,
      capacidadeNegocioDemandaKey: CapacidadeAtualKey,
    };
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/AdicionarServico",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaServicoCapacidade()
        RetornaSistemaCapacidade()
        setSuccess("Serviço adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const [SistemaServico, setSistemaServico] = useState([]);

  const RetornaSistemaServico = useCallback(async (servicosKey) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/RetornaSistemaServico",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: servicosKey,
    })
      .then((response) => {
        setSistemaServico(response.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        // error.response.data.map((er) => {
        //     setError(`${er.campo}: ${er.mensagem}`);
        // });
        console.log(error)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ListaServicoCapacidade = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/ListarServico?capacidadeNegocioDemandaKey=" + CapacidadeAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setCapacidadeServico(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ExcluirServicoCapacidade = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/ExcluirServico?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        ListaServicoCapacidade();
        RetornaSistemaCapacidade()
        setSuccess("Serviço excluído com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const RetornaSistemaCapacidade = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/RetornaSistema?capacidadeNegocioDemandaKey=" + CapacidadeAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false);
        setCapacidadeSistema(response.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        // error.response.data.map((er) => {
        //     setError(`${er.campo}: ${er.mensagem}`);
        // });
        console.log(error)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const [Visao, setVisao] = useState([])

  const RetornaMapaCalor = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemanda/ListarVisaoMapaCalor",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false);
        setVisao(response.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const [SwotMapaCalor, setSwotMapaCalor] = useState(null)

  const ObterSwotPorCapacidade = useCallback(async (areaKey, capacidadeNegocioKey, swotTI) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/ObterSowtPorCapacidadedeNegocio?empresaKey=" + `${EmpresaKey}` + "&areaKey=" + areaKey + "&CapacidadeNegocioKey=" + capacidadeNegocioKey + "&swotTi=" + swotTI,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setSwotMapaCalor(response.data);
        return response.data;
      })
      .catch((error) => {
        setSwotMapaCalor(null);
        if (error.response?.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        // "SWOT não encontrada" apenas indica que a capacidade ainda não possui SWOT;
        // nesse caso a modal permite cadastrar, então não exibimos erro ao usuário.
        const semSwot = Array.isArray(error.response?.data) && error.response.data.some((er) => (er.mensagem || "") === "SWOT não encontrada");
        if (!semSwot && Array.isArray(error.response?.data)) {
          error.response.data.map((er) => {
            setError(`${er.campo}: ${er.mensagem}`);
          });
          setTimeout(() => {
            setError("");
          }, 3000);
        }
      });
  }, [EmpresaKey]);

  const AdicionarSwotPeloMapaCalor = async (dados) => {
    setLoading(true);
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/AdicionarPeloMapaCalor",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: dados,
    })
      .then(() => {
        setLoading(false);
        setSuccess("SWOT adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return Promise.reject();
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  };

  const AdicionarItensDemanda = async (endpoint, descricao, status, currentPage) => {
    const token = Cookies.get("Token");
    let dados = {
      empresaKey: EmpresaKey,
      descricao: descricao,
      ativo: status,
      idExterno: "",
    };
    return axios({
      url: baseurl + endpoint + "/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: dados,
    })
      .then(() => {
        switch (endpoint) {
          case "CategorizacaoEstrategicaDemanda":
            ListaCategorizacaoConsulta(currentPage, 10);
            setSuccess("Categorização Estratégica adicionada com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          case "SetorGerenciaDemanda":
            ListaSetorGerenciaConsulta(currentPage, 10);
            setSuccess("Setor de Gerência adicionado com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          case "TipoDemanda":
            ListaTipoDemandaConsulta(currentPage, 10);
            setSuccess("Tipo da Demanda adicionada com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const EditarItensDemanda = async (endpoint, descricao, key, idExterno, currentPage) => {
    const token = Cookies.get("Token");
    let dados = {
      empresaKey: EmpresaKey,
      descricao: descricao,
      ativo: DemandaAtual.ativo,
      idExterno: idExterno
    };
    return axios({
      url: baseurl + endpoint + "/Alterar?Key=" + key,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: dados,
    })
      .then(() => {
        switch (endpoint) {
          case "CapacidadeNegocioDemanda":
            ListaCapacidadesConsulta(currentPage, 10);
            setSuccess("Capacidade de Negócio editada com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          case "CategorizacaoEstrategicaDemanda":
            ListaCategorizacaoConsulta(currentPage, 10);
            setSuccess("Categorização Estratégica editada com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          case "SetorGerenciaDemanda":
            ListaSetorGerenciaConsulta(currentPage, 10);
            setSuccess("Setor de Gerência editado com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          case "TipoDemanda":
            ListaTipoDemandaConsulta(currentPage, 10);
            setSuccess("Tipo da Demanda editada com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const AtualizarStatus = async (endpoint, key, status, currentPage) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + endpoint + "/Ativo?key=" + key + "&status=" + status,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        switch (endpoint) {
          case "CapacidadeNegocioDemanda":
            ListaCapacidadesConsulta(currentPage, 10);
            setSuccess("Capacidade de Negócio ativada/inativada com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          case "CategorizacaoEstrategicaDemanda":
            ListaCategorizacaoConsulta(currentPage, 10);
            setSuccess("Categorização Estratégica ativada/inativada com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          case "LinhaAtendimentoDemanda":
            ListaLinhaAtendimentoConsulta(currentPage, 10);
            setSuccess("Linha de Atendimento ativada/inativada com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          case "SetorGerenciaDemanda":
            ListaSetorGerenciaConsulta(currentPage, 10);
            setSuccess("Setor de Gerência ativado/inativado com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          case "TipoDemanda":
            ListaTipoDemandaConsulta(currentPage, 10);
            setSuccess("Tipo da Demanda ativado/inativado com sucesso.");
            setTimeout(() => {
              setSuccess("");
            }, 3000);
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ObterBSC = useCallback(async (BSCKey) => {
    setLoading(true)
    let arrayDiretrizes = [];
    let objDiretrizes = {};
    let arrayPrioridade = [];
    let objPrioridade = {};
    let arrayResumoPrioridade = [];
    let objResumoPrioridade = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "BSC/ObterBSC?empresaKey=" + `${EmpresaKey}` + "&BSCKey=" + BSCKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const bsc = eval(response.data)
        setBSCDados(bsc)
        const diretrizes = eval(response.data.diretrizEstrategica);
        const prioridades = eval(response.data.prioridades);
        const resumoPrioridades = eval(response.data.resumoPrioridades);
        let count = 0;
        diretrizes.forEach((e) => {
          const diretrizesItens = eval(
            response.data.diretrizEstrategicaItems
          ).filter((item) => item.diretrizEstrategicaId == e.id);
          let objDiretrizesItens = {};
          let arrayDiretrizesItens = [];
          diretrizesItens.forEach((item) => {
            count++;
            objDiretrizesItens = {
              letra: String.fromCharCode(count + 96).toUpperCase(),
              descricao: item.descricao,
              diretrizEstrategicaId: item.diretrizEstrategicaId,
              descricaoCompleta: item.descricaoCompleta,
              numeroOrdem: item.numeroOrdem,
              diretrizEstrategicaPrioridadeId: item.diretrizEstrategicaPrioridadeId,
              cobitP: item.cobitP,
              cobitS: item.cobitS,
              ordem: item.ordem,
              parcial: item.parcial,
              pesoGrupo: item.pesoGrupo,
              diretrizEstrategica: item.diretrizEstrategica,
              diretrizEstrategicaPrioridade: item.diretrizEstrategicaPrioridade,
              id: item.id,
              key: item.key,
            };
            arrayDiretrizesItens.push(objDiretrizesItens);
          });
          objDiretrizes = {
            empresaId: e.empresaId,
            descricao: e.descricao,
            pesoPorcentagem: e.pesoPorcentagem,
            pesoBSC: e.pesoBSC,
            empresa: e.empresa,
            id: e.id,
            key: e.key,
            itens: arrayDiretrizesItens,
          };
          arrayDiretrizes.push(objDiretrizes);
        });
        prioridades.forEach((p) => {
          objPrioridade = {
            empresaId: p.empresaId,
            descricao: p.descricao,
            peso: p.peso,
            empresa: p.empresa,
            id: p.id,
            key: p.key,
          };
          arrayPrioridade.push(objPrioridade);
        });
        resumoPrioridades.forEach((r) => {
          objResumoPrioridade = {
            x: r.prioridadeDescricao,
            y: r.porcentagem.toFixed(2),
            text: r.porcentagem.toFixed(2) + "%",
          };
          arrayResumoPrioridade.push(objResumoPrioridade);
        });
        setDiretrizEstrategica(arrayDiretrizes);
        setPrioridades(arrayPrioridade);
        setResumoPrioridades(arrayResumoPrioridade);
        return Promise.resolve()
      })
      .catch((error) => {
        // console.log(error)
        setLoading(false)
        // if (error.response.status === 401) {
        //   setLoading(false);
        //   setAuth(false)
        //   setError(`Sua sessão expirou, faça login novamente`)
        //   setTimeout(() => {
        //     setError("");
        //   }, 3000);
        //   return
        // }
        // if (typeof EmpresaKey != 'undefined') {
        //   error.response.data.map((er) => {
        //     setError(`${er.campo}: ${er.mensagem}`)
        //   })
        //   setTimeout(() => {
        //     setError("");
        //   }, 3000);
        // } else {
        //   setError("")
        // }
        return Promise.reject();
      });
  })

  const ObterBSCPorCiclo = useCallback(async (cicloKey) => {
    setLoading(true)
    let arrayDiretrizes = [];
    let objDiretrizes = {};
    let arrayPrioridade = [];
    let objPrioridade = {};
    let arrayResumoPrioridade = [];
    let objResumoPrioridade = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "BSC/ObterBSCPorCiclo?empresaKey=" + `${EmpresaKey}` + "&cicloKey=" + cicloKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const bsc = eval(response.data)
        setBSCDados(bsc)
        const diretrizes = eval(response.data.diretrizEstrategica);
        const prioridades = eval(response.data.prioridades);
        const resumoPrioridades = eval(response.data.resumoPrioridades);
        let count = 0;
        diretrizes.forEach((e) => {
          const diretrizesItens = eval(
            response.data.diretrizEstrategicaItems
          ).filter((item) => item.diretrizEstrategicaId == e.id);
          let objDiretrizesItens = {};
          let arrayDiretrizesItens = [];
          diretrizesItens.forEach((item) => {
            count++;
            objDiretrizesItens = {
              letra: String.fromCharCode(count + 96).toUpperCase(),
              descricao: item.descricao,
              diretrizEstrategicaId: item.diretrizEstrategicaId,
              descricaoCompleta: item.descricaoCompleta,
              numeroOrdem: item.numeroOrdem,
              diretrizEstrategicaPrioridadeId: item.diretrizEstrategicaPrioridadeId,
              cobitP: item.cobitP,
              cobitS: item.cobitS,
              ordem: item.ordem,
              parcial: item.parcial,
              pesoGrupo: item.pesoGrupo,
              diretrizEstrategica: item.diretrizEstrategica,
              diretrizEstrategicaPrioridade: item.diretrizEstrategicaPrioridade,
              id: item.id,
              key: item.key,
            };
            arrayDiretrizesItens.push(objDiretrizesItens);
          });
          objDiretrizes = {
            empresaId: e.empresaId,
            descricao: e.descricao,
            pesoPorcentagem: e.pesoPorcentagem,
            pesoBSC: e.pesoBSC,
            empresa: e.empresa,
            id: e.id,
            key: e.key,
            itens: arrayDiretrizesItens,
          };
          arrayDiretrizes.push(objDiretrizes);
        });
        prioridades.forEach((p) => {
          objPrioridade = {
            empresaId: p.empresaId,
            descricao: p.descricao,
            peso: p.peso,
            empresa: p.empresa,
            id: p.id,
            key: p.key,
          };
          arrayPrioridade.push(objPrioridade);
        });
        resumoPrioridades.forEach((r) => {
          objResumoPrioridade = {
            x: r.prioridadeDescricao,
            y: r.porcentagem.toFixed(2),
            text: r.porcentagem.toFixed(2) + "%",
          };
          arrayResumoPrioridade.push(objResumoPrioridade);
        });
        setDiretrizEstrategicaPorCiclo(arrayDiretrizes);
        setPrioridadesPorCiclo(arrayPrioridade);
        setResumoPrioridadesPorCiclo(arrayResumoPrioridade);
        return Promise.resolve()
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
        if (error.response.status === 401) {
          setLoading(false);
          setAuth(false)
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          return
        }
        if (typeof EmpresaKey != 'undefined') {
          error.response.data.map((er) => {
            setError(`${er.campo}: ${er.mensagem}`)
          })
          setTimeout(() => {
            setError("");
          }, 3000);
        } else {
          setError("")
        }
        return Promise.reject();
      });
  })

  const SimularBSC = async () => {
    let arrayDiretrizes = [];
    let objDiretrizes = {};
    let arrayPrioridade = [];
    let objPrioridade = {};
    let arrayResumoPrioridade = [];
    let objResumoPrioridade = {};
    const token = Cookies.get("Token");
    setLoading(true);
    return axios({
      url: baseurl + "BSC/Simulacao?empresaKey=" + `${EmpresaKey}`,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: BSCDados,
    })
      .then((response) => {
        setLoading(false)
        const bsc = eval(response.data)
        setBSCDados(prev => ({
          ...bsc,
          descricao: prev.descricao,
          padrao: prev.padrao,
        }))
        const diretrizes = eval(response.data.diretrizEstrategica);
        const prioridades = eval(response.data.prioridades);
        const resumoPrioridades = eval(response.data.resumoPrioridades);
        let count = 0;
        diretrizes.forEach((e) => {
          const diretrizesItens = eval(
            response.data.diretrizEstrategicaItems
          ).filter((item) => item.diretrizEstrategicaId == e.id);
          let objDiretrizesItens = {};
          let arrayDiretrizesItens = [];
          diretrizesItens.forEach((item) => {
            count++;
            objDiretrizesItens = {
              letra: String.fromCharCode(count + 96).toUpperCase(),
              descricao: item.descricao,
              diretrizEstrategicaId: item.diretrizEstrategicaId,
              descricaoCompleta: item.descricaoCompleta,
              numeroOrdem: item.numeroOrdem,
              diretrizEstrategicaPrioridadeId: item.diretrizEstrategicaPrioridadeId,
              cobitP: item.cobitP,
              cobitS: item.cobitS,
              ordem: item.ordem,
              parcial: item.parcial,
              pesoGrupo: item.pesoGrupo,
              diretrizEstrategica: item.diretrizEstrategica,
              diretrizEstrategicaPrioridade: item.diretrizEstrategicaPrioridade,
              id: item.id,
              key: item.key,
            };
            arrayDiretrizesItens.push(objDiretrizesItens);
          });
          objDiretrizes = {
            empresaId: e.empresaId,
            descricao: e.descricao,
            pesoPorcentagem: e.pesoPorcentagem,
            pesoBSC: e.pesoBSC,
            empresa: e.empresa,
            id: e.id,
            key: e.key,
            itens: arrayDiretrizesItens,
          };
          arrayDiretrizes.push(objDiretrizes);
        });
        prioridades.forEach((p) => {
          objPrioridade = {
            empresaId: p.empresaId,
            descricao: p.descricao,
            peso: p.peso,
            empresa: p.empresa,
            id: p.id,
            key: p.key,
          };
          arrayPrioridade.push(objPrioridade);
        });
        resumoPrioridades.forEach((r) => {
          objResumoPrioridade = {
            x: r.prioridadeDescricao,
            y: r.porcentagem,
            text: r.porcentagem.toFixed(2) + "%",
          };
          arrayResumoPrioridade.push(objResumoPrioridade);
        });
        setDiretrizEstrategica(arrayDiretrizes);
        setPrioridades(arrayPrioridade);
        setResumoPrioridades(arrayResumoPrioridade);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const AlterarGutBSC = async (key, g, u, t, diretriz, id) => {
    const gutPontos = g * u * t
    let gutBSC = 0
    if (diretriz.pesoBSC != 0) {
      gutBSC = gutPontos * diretriz.pesoBSC
    }
    const token = Cookies.get("Token");
    const data = {
      DemandaKey: key,
      DiretrizEstrategicaId: diretriz.id,
      GUT_Gravidade: g,
      GUT_Urgencia: u,
      GUT_Tendencia: t,
      GUT_Pontuacao: gutPontos,
      GUT_BSC_Pontuacao: gutBSC,
    }
    setLoading(true);
    return axios({
      url: baseurl + "Demanda/AlterarGutBSC",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,

    })
      .then((response) => {
        const novasDemandas = [...Demandas]
        const indiceNova = novasDemandas.findIndex((item) => item.id === id)
        if (indiceNova !== -1) {
          novasDemandas[indiceNova].guT_Gravidade = g
          novasDemandas[indiceNova].guT_Urgencia = u
          novasDemandas[indiceNova].guT_Tendencia = t
          novasDemandas[indiceNova].guT_Pontuacao = gutPontos
          novasDemandas[indiceNova].guT_BSC_Pontuacao = gutBSC
          novasDemandas[indiceNova].diretrizEstrategicaId = diretriz.id
        }
        setDemandas(novasDemandas)
        setLoading(false)
        setSuccess(response.data)
        setTimeout(() => {
          setSuccess("")
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("")
        }, 3000);
        return Promise.reject();
      });
  }

  const SalvarBSC = async (bscAtualizado) => {
    const token = Cookies.get("Token");
    setLoading(true);
    return axios({
      url: baseurl + "BSC/Salvar?empresaKey=" + `${EmpresaKey}`,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: bscAtualizado,
    })
      .then((response) => {
        ListaBSCConsulta(bscAtualizado?.cicloDemandaKey, 1, 10)
        setShow(true)
        setLoading(false)
        setSuccess(response.data)
        setTimeout(() => {
          setSuccess("")
        }, 3000);
        ObterBSC(bscAtualizado?.bscKey)
        setModalBSCPadrao(false)
        setModalEditarBSC(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setShow(true)
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("")
        }, 3000);
        return Promise.reject();
      });
  }

  const AdicionarComentario = async () => {
    const token = Cookies.get("Token");
    setLoading(true);

    const linkRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|([^\s]+\.[a-zA-Z]{2,})/g;
    const comentarioTexto = AddComentario.comentario;
    let comentarioRenderizado = comentarioTexto;

    const isLink = linkRegex.test(comentarioRenderizado)
    if (isLink) {
      comentarioRenderizado = comentarioTexto.replace(linkRegex, (match) => {
        if (match.startsWith("http") || match.startsWith("www")) {
          if (match.startsWith("www")) {
            return `<a href="http://${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
          }
          return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
        } else {
          return `<a href="http://${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
        }
      });
    }

    const data = {
      demandaKey: DemandaAtualKey,
      comentario: comentarioRenderizado,
      dataHora: AddComentario.dataHora,
    };

    try {
      if (typeof comentarioRenderizado === "undefined") {
        setError("Campo comentário em branco.")
        setTimeout(() => {
          setError("");
        }, 3000);
        setLoading(false);
        return;
      }
    } catch (error) {
    }
    return axios({
      url: baseurl + "Demanda/AdicionarComentario",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaComentario()
        setSuccess("Comentário adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
        comentarioRef.current.value = "";
        setAddComentario({
          comentario: ""
        });
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaComentario = async () => {
    let arrayComentario = [];
    let objComentario = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ListarComentario?demandaKey=" + DemandaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          objComentario = {
            comentario: e.comentario,
            dataHora: e.dataHora,
            nome: e.usuario.nome,
            keyComentario: e.key
          };
          arrayComentario.push(objComentario);
        });
        setComentario(arrayComentario.reverse());
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirComentario = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ExcluirComentario?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        ListaComentario();
        setSuccess(response.data);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const AdicionarLink = async () => {
    const token = Cookies.get("Token");
    setLoading(true);
    const data = {
      demandaKey: DemandaAtualKey,
      link: AddLink.addLink,
      descricao: AddLink.descricaoLink,
      dataHora: AddLink.dataHora,
    };
    try {
      if (typeof AddLink.addLink === "undefined") {
        setError("Campo link em branco.")
        setTimeout(() => {
          setError("");
        }, 3000);
        setLoading(false);
        return;
      }
    } catch (error) {
    }
    return axios({
      url: baseurl + "Demanda/AdicionarLink",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaLink()
        setSuccess("Link adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
        linkRef.current.value = '';
        descricaoRef.current.value = '';
        setAddLink({
          link: "",
          descricao: "",
        });
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaLink = useCallback(async () => {
    let arrayLink = [];
    let objLink = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ListarLink?demandaKey=" + DemandaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          objLink = {
            nome: e.usuario.nome,
            dataHora: e.dataHora,
            descricao: e.descricao,
            link: e.link,
            keyLink: e.key
          };
          arrayLink.push(objLink);
        });
        setLink(arrayLink.reverse());
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ExcluirLink = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ExcluirLink?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        ListaLink();
        setSuccess(response.data);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const AdicionarAnexo = async () => {
    const token = Cookies.get("Token");

    if (!AddFile) {
      setError("Campo anexo em branco.");
      setTimeout(() => setError(""), 3000);
      return;
    }

    setLoading(true);

    const convertFileToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
      });
    };

    try {
      const base64File = await convertFileToBase64(AddFile);

      const data = {
        demandaKey: DemandaAtualKey,
        file: base64File,
        fileName: AddFile.name,
        contentType: AddFile.type
      };

      await axios.post(baseurl + "Demanda/AdicionarAnexo", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      ListaAnexo()
      setSuccess("Anexo adicionado com sucesso.");
      setTimeout(() => setSuccess(""), 3000);
    } catch (error) {
      console.error(error);
      setError("Erro ao adicionar anexo.");
      setTimeout(() => setError(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  const ListaAnexo = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ListarAnexo?demandaKey=" + DemandaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFile(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const BaixarAnexo = useCallback(async (key) => {
    const token = Cookies.get("Token");

    try {
      const response = await axios.get(`${baseurl}Demanda/BaixarAnexo?key=${key}`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      });

      const blob = new Blob([response.data], { type: response.headers["content-type"] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      let fileName = "arquivo";
      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match) fileName = match[1];
      } else {
        const extension = response.headers["content-type"].split("/")[1];
        fileName = `arquivo.${extension}`;
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Erro ao baixar o anexo:", error);
    }
  }, []);


  const ExcluirAnexo = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ExcluirAnexo?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        ListaAnexo()
        setSuccess(response.data);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const AdicionarRisco = async () => {
    const token = Cookies.get("Token");
    setLoading(true);
    const data = {
      demandaKey: DemandaAtualKey,
      riscoAtual: AddRisco.riscoAtual,
      riscoAtualJustificativa: AddRisco.riscoAtualJustificativa,
      mitigacaoRisco: AddRisco.mitigacaoRisco,
      mitigacaoRiscoJustificativa: AddRisco.mitigacaoRiscoJustificativa,
    };
    return axios({
      url: baseurl + "Demanda/AdicionarRisco",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaRisco()
        setSuccess("Risco adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
        riscoJustificativaRef.current.value = '';
        mitigacaoJustificativaRef.current.value = '';

        const checkboxes = document.getElementsByName("riscoAtual");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        const mitigacaoCheckboxes = document.getElementsByName("mitigacaoRisco");
        mitigacaoCheckboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        setAddRisco({
          riscoAtual: '',
          riscoAtualJustificativa: '',
          mitigacaoRisco: '',
          mitigacaoRiscoJustificativa: ''
        })
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaRisco = useCallback(async () => {
    let arrayRisco = [];
    let objRisco = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ListarRisco?demandaKey=" + DemandaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          objRisco = {
            riscoAtual: e.riscoAtual,
            riscoAtualJustificativa: e.riscoAtualJustificativa,
            mitigacaoRisco: e.mitigacaoRisco,
            mitigacaoRiscoJustificativa: e.mitigacaoRiscoJustificativa,
            keyRisco: e.key,
          };
          arrayRisco.push(objRisco);
        });
        setRisco(arrayRisco.reverse());
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const EditarRisco = async (risco, riscoJustificativa, mitigacao, mitigacaoJustificativa, key) => {
    const token = Cookies.get("Token")
    const data = {
      demandaKey: DemandaAtualKey,
      riscoAtual: risco,
      riscoAtualJustificativa: riscoJustificativa,
      mitigacaoRisco: mitigacao,
      mitigacaoRiscoJustificativa: mitigacaoJustificativa,
      demandaRiscoKey: key
    }
    return axios({
      url: baseurl + "Demanda/AlterarRisco?key=" + key,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data
    })
      .then((response) => {
        ListaRisco()
        setRiscoEditar(false)
        setSuccess(response.data)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        riscoJustificativaRef.current.value = '';
        mitigacaoJustificativaRef.current.value = '';

        const checkboxes = document.getElementsByName("riscoAtual");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        const mitigacaoCheckboxes = document.getElementsByName("mitigacaoRisco");
        mitigacaoCheckboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      })
  }

  const ExcluirRisco = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ExcluirRisco?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        ListaRisco();
        setSuccess(response.data);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const AdicionarDemandaCiclo = async (props) => {
    setLoading(true)
    let listaDemandas = []
    let objDemandas = {}
    props.forEach((item, index) => {
      objDemandas = {
        cicloOrdem: index + 1,
        demandaKey: item.id
      }
      listaDemandas.push(objDemandas)
    })
    const token = Cookies.get("Token")
    const { cicloDataInicial, cicloDataFinal } = CadastroCiclo;
    if (!CadastroCiclo || !cicloDataInicial || !cicloDataFinal) {
      setError("Preencha todos os campos.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return Promise.reject();
    }

    const cicloDataInicialISO = new Date(cicloDataInicial).toISOString();
    const cicloDataFinalISO = new Date(cicloDataFinal).toISOString();
    try {
      if (CadastroCiclo === "") {
        setError("Formulário vazio.");
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      }
      if (!CadastroCiclo.cicloDescricao) {
        setError("Campo descrição obrigatório.")
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      }
      if (!cicloDataFinalISO) {
        setError("Campo data inicial obrigatório.")
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      }
      if (!cicloDataInicialISO) {
        setError("Campo data final obrigatório.")
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      }
      if (!CadastroCiclo.cicloObservacao) {
        setError("Campo observação obrigatório.")
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      }
    } catch (error) {
    }
    const data = {
      empresaKey: EmpresaKey,
      cicloDescricao: CadastroCiclo.cicloDescricao,
      cicloDataInicial: cicloDataInicialISO,
      cicloDataFinal: cicloDataFinalISO,
      cicloObservacao: CadastroCiclo.cicloObservacao,
      demandaCicloOrdens: listaDemandas,
    };
    return axios({
      url: baseurl + "Demanda/AdicionarDemandasNovoCiclo",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        setLoading(false)
        setSuccess("Demanda(s) adicionada(s) no novo ciclo com sucesso.");
        setModalEnviarCiclo(false)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        ListaDemanda(true, 'PRIORIZACAO', 1, 50)
        ListaCiclos()
        return Promise.resolve()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      })
  }

  const EditarRole = async (Admin, Supervisor, Leitor, Nome, Permissoes) => {
    const token = Cookies.get("Token")
    const empresaKey = Cookies.get('Key')
    setLoading(true)
    let data = {
      empresaKey: empresaKey,
      nome: Nome,
      supervisor: Supervisor,
      admin: Admin,
      somenteVisualizar: Leitor,
      id: UserId,
      urlOrigem: dominio,
      permissoes: Permissoes,
      areas: EdicaoUsuario.areas
    }
    return axios({
      url: baseurl + "Autenticacao/EditarUsuario",
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      data: data
    })
      .then((response) => {
        setModalTrocarRole(false)
        setSuccess("Usuário editado com sucesso!");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        ListaUsuarios()
        ListarMenuUsuario(UserId)
        setLoading(false)
        return Promise.resolve(response.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        setLoading(false)
        return Promise.reject(error)
      })
  }

  const ExcluirDemandaCiclo = async (demandaKey, cicloKey) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/RemoverCiclo?demandaKey=" + demandaKey + "&cicloKey=" + cicloKey,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        ListaCiclos();
        ListaDemanda(false, 'PRIORIZACAO', 1, 50)
        ListaCicloDemanda(demandaKey)
        setSuccess(response.data);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirCiclo = async (key) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "Demanda/ExcluirCiclo?Key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaCiclos()
        setSuccess("Ciclo excluído com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirCiclo(false)
      })
      .catch((error) => {
        console.log(error)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const ListaCicloDemanda = useCallback(async (key) => {
    let arrayciclo = []
    let objciclo = {}
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ListarCiclos?demandaKey=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          objciclo = {
            cicloId: e.cicloId,
            usuarioId: e.usuarioId,
            usuarioNome: e.usuario.nome,
            dataHora: e.dataHora,
            cicloKey: e.ciclo.key,
            cicloOrdem: e.cicloOrdem,
            cicloDescricao: e.ciclo.descricao,
            keyCiclo: e.key,
            guT_Pontuacao: e.guT_Pontuacao,
            guT_BSC_Pontuacao: e.guT_BSC_Pontuacao
          };
          arrayciclo.push(objciclo);
        });
        setCicloDem(arrayciclo);
        return Promise.resolve()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }, [DemandaAtualKey])

  const CancelarDemanda = async () => {
    setLoading(true)
    const token = Cookies.get("Token");
    try {
      if (MotivoCancelar.motivo === '') {
        setError("Motivo é obrigatório.");
        setTimeout(() => {
          setError("");
        }, 3000);
        setLoading(false)
        return;
      }
    } catch (error) {
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
    }
    const data = {
      demandaKey: DemandaAtualKey,
      motivo: MotivoCancelar.motivo,
    }
    return axios({
      url: baseurl + 'Demanda/Cancelar',
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        setLoading(false)
        setSuccess("Demanda cancelada com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setCancelarDemandaModal(false)
        setMotivoCancelar('')
        ListaDemanda(true, "", 1, 50)
        return Promise.resolve()
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      })
  }

  const ConcluirDemanda = async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + 'Demanda/Concluir?key=' + DemandaAtualKey,
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setSuccess(response.data)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        ListaDemanda(true, "", 1, 50)
        setConcluirDemandaModal(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const CompartilharDemanda = async () => {
    setLoading(true)
    const url = new URL(window.location.href);
    const token = Cookies.get("Token");
    const data = {
      demandaKey: DemandaAtualKey,
      diasValidade: Compartilhar.diasValidade
    }
    return axios({
      url: baseurl + "Demanda/Compartilhar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then((response) => {
        setLoading(false)
        setSuccess("Demanda compartilhada com sucesso.");
        setUrlCompartilhar(url.origin)
        setKeyCompartilhar(response.data)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setAuth(false)
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      })
  }

  const VerCompartilhada = async (key) => {
    return axios({
      url: baseurl + 'Demanda/VerCompartilhada?key=' + key,
      method: 'GET',
    })
      .then((response) => {
        const dem = response.data;
        const objDemandas = {
          id: dem.id,
          key: dem.key,
          titulo: dem.titulo,
          descricao: dem.descricao,
          criacaoUsuarioNome: dem.criacaoUsuarioNome,
          criacaoDataHora: dem.criacaoDataHora,
          solicitante: dem.solicitante,
          dataLimite: dem.dataLimite,
          faseDemandaId: dem.faseDemandaId,
          faseDescricao: dem.faseDescricao,
          setorGerenciaDescricao: dem.setorGerenciaDescricao,
          tipoDescricao: dem.tipoDescricao,
          linhaAtendimentoId: dem.linhaAtendimentoId,
          linhaAtendimentoDescricao: dem.linhaAtendimentoDescricao,
          diretrizEstrategicaDescricao: dem.diretrizEstrategicaDescricao,
          diretrizEstrategicaId: dem.diretrizEstrategicaId,
          pesoBSC: dem.pesoBSC,
          guT_Gravidade: dem.guT_Gravidade,
          guT_Urgencia: dem.guT_Urgencia,
          guT_Tendencia: dem.guT_Tendencia,
          guT_Pontuacao: dem.guT_Pontuacao,
          guT_BSC_Pontuacao: dem.guT_BSC_Pontuacao,
          expectativaEntrega: dem.expectativaEntrega,
          esforcoTotal: dem.esforcoTotal,
          cancelamentoDataHora: dem.cancelamentoDataHora,
          conclusaoDataHora: dem.conclusaoDataHora,
          cicloDescricao: dem.cicloDescricao,
          cicloOrdem: dem.cicloOrdem,
        }
        setDemCompartilhada(objDemandas)
        return Promise.resolve()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        return Promise.reject()
      })
  }

  const ListarCompartilhamentos = async (key) => {
    let arrayDem = []
    let objDem = {}
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + 'Demanda/ListarCompartilhamentos?demandaKey=' + key,
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const dem = response.data;
        dem.forEach((e) => {
          objDem = {
            demandaId: e.demandaId,
            usuarioId: e.usuarioId,
            dataHora: e.dataHora,
            dataValidade: e.dataValidade !== 'undefined' ? e.dataValidade : '',
            quantidadeLeituras: e.quantidadeLeituras,
            demanda: e.demanda,
            usuario: e.usuario,
            id: e.id,
            key: e.key
          }
          arrayDem.push(objDem)
        })
        setListaDemCompartilhada(arrayDem)
        return Promise.resolve()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        return Promise.reject()
      })
  }

  const CriarSwot = async (currentPage, swotTI) => {
    setLoading(true)
    const token = Cookies.get("Token");
    const data = {
      empresaKey: EmpresaKey,
      descricao: Swot.descricao,
      areaKey: Swot.areaKey,
      forca: ForcaSwot,
      fraqueza: FraquezaSwot,
      oportunidade: OportunidadeSwot,
      ameaca: AmeacaSwot,
      cicloDemandaKey: Swot.cicloDemandaKey,
      idExterno: Swot.idExterno,
      swotTI: swotTI
    };
    if (typeof Swot.descricao === "undefined" || Swot.descricao === "0") {
      setLoading(false)
      setError("Descrição não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof Swot.areaKey === "undefined" || Swot.areaKey === "0") {
      setLoading(false)
      setError("Área não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof Swot.cicloDemandaKey === "undefined" || Swot.cicloDemandaKey === "0") {
      setLoading(false)
      setError("Ciclo não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    return axios({
      url: baseurl + "Swot/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        setLoading(false);
        ListaSwotConsulta(currentPage, 10, swotTI)
        setSuccess("SWOT adicionado com sucesso.");
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setSwot({})
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const EditarSwot = async (currentPage, swotTI) => {
    const token = Cookies.get("Token");
    const data = {
      empresaKey: EmpresaKey,
      descricao: SwotObter.descricao,
      areaKey: SwotObter.areaKey || SwotObter.area.key,
      cicloDemandaKey: SwotObter.cicloDemandaKey || SwotObter.cicloDemanda.key,
      idExterno: SwotObter.idExterno,
      empresaKey: EmpresaKey,
      swotTI: swotTI,
    };
    return axios({
      url: baseurl + "Swot/Alterar?key=" + SwotAtualKey,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaSwotConsulta(currentPage, 10, swotTI);
        setSuccess("SWOT editado com sucesso!");
        setModalEditarDemanda(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setSwotObter([])
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaSwot = useCallback(async () => {
    let objSwot = {};
    let arraySwot = [];
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Swot/Listar?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const swot = eval(response.data);
        swot.forEach((e) => {
          objSwot = {
            descricao: e.descricao,
            dataCriacao: e.dataCriacao,
            usuario: e.usuario.nome,
            key: e.key,
            areaKey: e.areaKey,
            cicloDemandaKey: e.cicloDemandaKey,
            area: e.area,
            cicloDemanda: e.cicloDemanda,
            idExterno: e.idExterno,
            swotTI: e.swotTI
          };
          arraySwot.push(objSwot);
        });
        setSwotLista(arraySwot);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [totalRegistrosSwot, setTotalRegistrosSwot] = useState(0);

  const ListaSwotConsulta = useCallback(async (posicao, qtd, swotTI) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "Swot/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&posicao=" + posicao + "&quantidade=" + qtd + "&SwotTI=" + swotTI,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        descricao: e.descricao,
        dataCriacao: e.dataCriacao,
        usuario: e.usuario,
        key: e.key,
        areaKey: e.areaKey,
        cicloDemandaKey: e.cicloDemandaKey,
        area: e.area,
        cicloDemanda: e.cicloDemanda,
        idExterno: e.idExterno,
        swotTI: e.swotTI
      }));
      setSwotListaConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosSwot(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroSwot, setFiltroSwot] = useState([]);
  const [totalRegistrosFiltroSwot, setTotalRegistrosFiltroSwot] = useState(0);

  const ListaFiltroSwot = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroSwot(response.data.data);
        setTotalRegistrosFiltroSwot(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ListaSwotPorCiclo = useCallback(async (id) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Swot/ListarPorCiclo?empresaKey=" + EmpresaKey + "&cicloId=" + id + "&SwotTI=false",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setSwotPorCiclo(response.data)
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [SwotTiPorCiclo, setSwotTiPorCiclo] = useState([]);

  const ListaSwotTiPorCiclo = useCallback(async (id) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Swot/ListarPorCiclo?empresaKey=" + EmpresaKey + "&cicloId=" + id + "&SwotTI=true",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setSwotTiPorCiclo(response.data)
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const ObterSwot = useCallback(async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/ObterKey?key=" + key,
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const swot = response.data;
        const objSwot = {
          empresaId: swot.empresaId,
          descricao: swot.descricao,
          dataCriacao: swot.dataCriacao,
          usuarioId: swot.usuarioId,
          usuario: swot.usuario,
          empresa: swot.empresa,
          id: swot.id,
          key: swot.key,
          areaId: swot.areaId,
          cicloDemandaId: swot.cicloDemandaId,
          area: swot.area,
          cicloDemanda: swot.cicloDemanda,
          idExterno: swot.idExterno,
          swotTI: swot.swotTI
        }
        setSwotObter(objSwot);
        return Promise.resolve()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        console.log(error)
        return Promise.reject()
      })
  })

  const ExcluirSwot = async (key, currentPage, swotTI) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "Swot/Excluir?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaSwotConsulta(currentPage, 10, swotTI)
        setSuccess("SWOT excluído com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirDemanda(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const AdicionarSwotItem = async () => {
    const token = Cookies.get("Token");
    setLoading(true);
    if (!AddSwotItem) {
      setError("Preencha os valores.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (!AddSwotItem.capacidadeNegocioDemandaKey || AddSwotItem.capacidadeNegocioDemandaKey == "") {
      setError("Capacidade: campo obrigatório.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (!AddSwotItem.gravidade || AddSwotItem.gravidade == "") {
      setError("Gravidade: campo obrigatório.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (!AddSwotItem.urgencia || AddSwotItem.urgencia == "") {
      setError("Urgência: campo obrigatório.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (!AddSwotItem.tendencia || AddSwotItem.tendencia == "") {
      setError("Tendência: campo obrigatório.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      swotKey: SwotAtualKey,
      capacidadeNegocioDemandaKey: AddSwotItem.capacidadeNegocioDemandaKey,
      gravidade: AddSwotItem.gravidade,
      urgencia: AddSwotItem.urgencia,
      tendencia: AddSwotItem.tendencia,
      gut: AddSwotItem.gut,
      tipo: AddSwotItem.tipo,
    };
    return axios({
      url: baseurl + "Swot/AdicionarItem",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaSwotItem()
        setSuccess("Adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
        setAddSwotItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
        setForcaItemItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
        setFraquezaItemItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
        setOportunidadeItemItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
        setAmeacaItemItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaSwotItem = useCallback(async () => {
    let objSwot = {};
    let arraySwot = [];
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Swot/ListarItem?SwotKey=" + SwotAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const swot = eval(response.data);
        swot.forEach((e) => {
          objSwot = {
            swotId: e.swotId,
            capacidadeNegocioDemandaId: e.capacidadeNegocioDemandaId,
            gravidade: e.gravidade,
            urgencia: e.urgencia,
            tendencia: e.tendencia,
            gut: e.gut,
            tipo: e.tipo,
            swot: e.swot,
            capacidadeNegocioDemanda: e.capacidadeNegocioDemanda,
            id: e.id,
            key: e.key
          };
          arraySwot.push(objSwot);
        });
        setSwotItemLista(arraySwot);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const ExcluirSwotItem = async (key) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/ExcluirItem?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false);
        ListaSwotItem();
        setSuccess("Excluído com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaMatriz = useCallback(async (key) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Swot/Matriz?key=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const swotData = eval(response.data);
        let objSwot = {
          empresaId: swotData.swot.empresaId,
          descricao: swotData.swot.descricao,
          dataCriacao: swotData.swot.dataCriacao,
          usuarioId: swotData.swot.usuarioId,
          usuario: swotData.swot.usuario,
          empresa: swotData.swot.empresa,
          id: swotData.swot.id,
          key: swotData.swot.key,
          forcas: [],
          fraquezas: [],
          oportunidades: [],
          ameacas: []
        };
        objSwot.forcas = swotData.forca.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.fraquezas = swotData.fraqueza.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.oportunidades = swotData.oportunidade.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.ameacas = swotData.ameaca.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));

        setSwotMatriz(objSwot);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [SwotMatrizTi, setSwotMatrizTi] = useState([])

  const ListaMatrizTi = useCallback(async (key) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Swot/Matriz?key=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const swotData = eval(response.data);
        let objSwot = {
          empresaId: swotData.swot.empresaId,
          descricao: swotData.swot.descricao,
          dataCriacao: swotData.swot.dataCriacao,
          usuarioId: swotData.swot.usuarioId,
          usuario: swotData.swot.usuario,
          empresa: swotData.swot.empresa,
          id: swotData.swot.id,
          key: swotData.swot.key,
          forcas: [],
          fraquezas: [],
          oportunidades: [],
          ameacas: []
        };
        objSwot.forcas = swotData.forca.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.fraquezas = swotData.fraqueza.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.oportunidades = swotData.oportunidade.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.ameacas = swotData.ameaca.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        setSwotMatrizTi(objSwot);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const ListaRelatorio = useCallback(async (key) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Swot/Relatorio?key=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const swotData = eval(response.data);
        let objSwot = {
          empresaId: swotData.swot.empresaId,
          descricao: swotData.swot.descricao,
          dataCriacao: swotData.swot.dataCriacao,
          usuarioId: swotData.swot.usuarioId,
          usuario: swotData.swot.usuario,
          empresa: swotData.swot.empresa,
          id: swotData.swot.id,
          key: swotData.swot.key,
          indice: swotData.indice,
          porcentagemForca: swotData.porcentagemForca,
          porcentagemFraqueza: swotData.porcentagemFraqueza,
          porcentagemOportunidade: swotData.porcentagemOportunidade,
          porcentagemAmeaca: swotData.porcentagemAmeaca,
          quantidadeForca: swotData.quantidadeForca,
          quantidadeFraqueza: swotData.quantidadeFraqueza,
          quantidadeOportunidade: swotData.quantidadeOportunidade,
          quantidadeAmeaca: swotData.quantidadeAmeaca,
          forcas: [],
          fraquezas: [],
          oportunidades: [],
          ameacas: []
        };
        objSwot.forcas = swotData.forca.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.fraquezas = swotData.fraqueza.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.oportunidades = swotData.oportunidade.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.ameacas = swotData.ameaca.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));

        setSwotRelatorio(objSwot);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [SwotTiRelatorio, setSwotTiRelatorio] = useState([]);

  const ListaRelatorioSwotTi = useCallback(async (key) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Swot/Relatorio?key=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const swotData = eval(response.data);
        let objSwot = {
          empresaId: swotData.swot.empresaId,
          descricao: swotData.swot.descricao,
          dataCriacao: swotData.swot.dataCriacao,
          usuarioId: swotData.swot.usuarioId,
          usuario: swotData.swot.usuario,
          empresa: swotData.swot.empresa,
          id: swotData.swot.id,
          key: swotData.swot.key,
          indice: swotData.indice,
          porcentagemForca: swotData.porcentagemForca,
          porcentagemFraqueza: swotData.porcentagemFraqueza,
          porcentagemOportunidade: swotData.porcentagemOportunidade,
          porcentagemAmeaca: swotData.porcentagemAmeaca,
          quantidadeForca: swotData.quantidadeForca,
          quantidadeFraqueza: swotData.quantidadeFraqueza,
          quantidadeOportunidade: swotData.quantidadeOportunidade,
          quantidadeAmeaca: swotData.quantidadeAmeaca,
          forcas: [],
          fraquezas: [],
          oportunidades: [],
          ameacas: []
        };
        objSwot.forcas = swotData.forca.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.fraquezas = swotData.fraqueza.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.oportunidades = swotData.oportunidade.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));
        objSwot.ameacas = swotData.ameaca.map((item) => ({
          swotId: item.swotId,
          capacidadeNegocioDemandaId: item.capacidadeNegocioDemandaId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          capacidadeNegocioDemanda: item.capacidadeNegocioDemanda
        }));

        setSwotTiRelatorio(objSwot);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const CriarSwotServico = async (currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token");
    const data = {
      empresaKey: EmpresaKey,
      descricao: SwotServico.descricao,
      areaKey: SwotServico.areaKey,
      forca: ForcaSwotServico,
      fraqueza: FraquezaSwotServico,
      oportunidade: OportunidadeSwotServico,
      ameaca: AmeacaSwotServico,
      cicloDemandaKey: SwotServico.cicloDemandaKey,
      idExterno: SwotServico.idExterno
    };
    if (typeof SwotServico.descricao === "undefined" || SwotServico.descricao === "0") {
      setLoading(false)
      setError("Descrição não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof SwotServico.areaKey === "undefined" || SwotServico.areaKey === "0") {
      setLoading(false)
      setError("Área não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof SwotServico.cicloDemandaKey === "undefined" || SwotServico.cicloDemandaKey === "0") {
      setLoading(false)
      setError("Ciclo não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    return axios({
      url: baseurl + "SwotServico/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        setLoading(false);
        setSuccess("SWOT adicionado com sucesso.");
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        ListaSwotServicoConsulta(currentPage, 10)
        setSwotServico({})
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const EditarSwotServico = async (currentPage) => {
    const token = Cookies.get("Token");
    const data = {
      empresaKey: EmpresaKey,
      descricao: SwotServicoObter.descricao,
      areaKey: SwotServicoObter.areaKey || SwotServicoObter.area.key,
      cicloDemandaKey: SwotServicoObter.cicloDemandaKey || SwotServicoObter.cicloDemanda.key,
      idExterno: SwotServicoObter.idExterno,
      empresaKey: EmpresaKey
    };
    return axios({
      url: baseurl + "SwotServico/Alterar?key=" + SwotServicoAtualKey,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaSwotServicoConsulta(currentPage, 10);
        setSuccess("Swot de Serviço editado com sucesso!");
        setModalEditarDemanda(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setSwotServicoObter([])
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaSwotServico = useCallback(async () => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "SwotServico/Listar?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setSwotServicoLista(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        // error.response.data.map((er) => {
        //   setError(`${er.campo}: ${er.mensagem}`)
        // })
        console.log(error)
        return Promise.reject();
      });
  })

  const [totalRegistrosSwotServico, setTotalRegistrosSwotServico] = useState(0);

  const ListaSwotServicoConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "SwotServico/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        descricao: e.descricao,
        dataCriacao: e.dataCriacao,
        usuario: e.usuario,
        key: e.key,
        areaKey: e.areaKey,
        cicloDemandaKey: e.cicloDemandaKey,
        area: e.area,
        cicloDemanda: e.cicloDemanda,
        idExterno: e.idExterno
      }));
      setSwotServicoListaConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosSwotServico(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroSwotServico, setFiltroSwotServico] = useState([]);
  const [totalRegistrosFiltroSwotServico, setTotalRegistrosFiltroSwotServico] = useState(0);

  const ListaFiltroSwotServico = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "SwotServico/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroSwotServico(response.data.data);
        setTotalRegistrosFiltroSwotServico(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const [ServicosPorArea, setServicosPorArea] = useState([]);

  const ListaServicoPorArea = useCallback(async (cicloId, areaKey) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "SwotServico/ListarPorArea?empresaKey=" + `${EmpresaKey}` + "&cicloId=" + cicloId + "&areaKey=" + areaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setServicosPorArea(response.data);
      })
      .catch((error) => {
        setServicosPorArea([]);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        // error.response.data.map((er) => {
        //   setError(`${er.campo}: ${er.mensagem}`)
        // })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ListaSwotServicoPorCiclo = useCallback(async (id) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "SwotServico/ListarPorCiclo?empresaKey=" + EmpresaKey + "&cicloId=" + id,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setSwotServicoPorCiclo(response.data)
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const ObterSwotServico = useCallback(async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "SwotServico/ObterKey?key=" + key,
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setSwotServicoObter(response.data);
        return Promise.resolve()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        console.log(error)
        return Promise.reject()
      })
  })

  const ExcluirSwotServico = async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "SwotServico/Excluir?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaSwotServicoConsulta(currentPage, 10)
        setSuccess("SWOT excluído com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirDemanda(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const AdicionarSwotServicoItem = async () => {
    const token = Cookies.get("Token");
    setLoading(true);
    if (!AddSwotServicoItem) {
      setError("Preencha os valores.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (!AddSwotServicoItem.servicoKey || AddSwotServicoItem.servicoKey == "") {
      setError("Serviço: campo obrigatório.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (!AddSwotServicoItem.gravidade || AddSwotServicoItem.gravidade == "") {
      setError("Gravidade: campo obrigatório.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (!AddSwotServicoItem.urgencia || AddSwotServicoItem.urgencia == "") {
      setError("Urgência: campo obrigatório.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (!AddSwotServicoItem.tendencia || AddSwotServicoItem.tendencia == "") {
      setError("Tendência: campo obrigatório.");
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      swotServicoKey: SwotServicoAtualKey,
      servicoKey: AddSwotServicoItem.servicoKey,
      gravidade: AddSwotServicoItem.gravidade,
      urgencia: AddSwotServicoItem.urgencia,
      tendencia: AddSwotServicoItem.tendencia,
      gut: AddSwotServicoItem.gut,
      tipo: AddSwotServicoItem.tipo,
    };
    return axios({
      url: baseurl + "SwotServico/AdicionarItem",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaSwotServicoItem()
        setSuccess("Adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
        setAddSwotServicoItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
        setForcaServicoItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
        setFraquezaServicoItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
        setOportunidadeServicoItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
        setAmeacaServicoItem({
          capacidadeNegocioDemandaKey: "",
          gravidade: "",
          urgencia: "",
          tendencia: "",
          gut: "",
          tipo: "",
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaSwotServicoItem = useCallback(async () => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "SwotServico/ListarItem?SwotKey=" + SwotServicoAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setSwotServicoItemLista(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const ExcluirSwotServicoItem = async (key) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "SwotServico/ExcluirItem?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false);
        ListaSwotServicoItem();
        setSuccess("Excluído com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaMatrizServico = useCallback(async (key) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "SwotServico/Matriz?key=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const swotData = eval(response.data);
        let objSwot = {
          empresaId: swotData.swot.empresaId,
          descricao: swotData.swot.descricao,
          dataCriacao: swotData.swot.dataCriacao,
          usuarioId: swotData.swot.usuarioId,
          usuario: swotData.swot.usuario,
          empresa: swotData.swot.empresa,
          id: swotData.swot.id,
          key: swotData.swot.key,
          forcas: [],
          fraquezas: [],
          oportunidades: [],
          ameacas: []
        };
        objSwot.forcas = swotData.forca.map((item) => ({
          swotServicoId: item.swotServicoId,
          servicoId: item.servicoId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          servico: item.servico
        }));
        objSwot.fraquezas = swotData.fraqueza.map((item) => ({
          swotServicoId: item.swotServicoId,
          servicoId: item.servicoId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          servico: item.servico
        }));
        objSwot.oportunidades = swotData.oportunidade.map((item) => ({
          swotServicoId: item.swotServicoId,
          servicoId: item.servicoId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          servico: item.servico
        }));
        objSwot.ameacas = swotData.ameaca.map((item) => ({
          swotServicoId: item.swotServicoId,
          servicoId: item.servicoId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          servico: item.servico
        }));
        setSwotServicoMatriz(objSwot);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const ListaRelatorioServico = useCallback(async (key) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "SwotServico/Relatorio?key=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const swotData = eval(response.data);
        let objSwot = {
          empresaId: swotData.swot.empresaId,
          descricao: swotData.swot.descricao,
          dataCriacao: swotData.swot.dataCriacao,
          usuarioId: swotData.swot.usuarioId,
          usuario: swotData.swot.usuario,
          empresa: swotData.swot.empresa,
          id: swotData.swot.id,
          key: swotData.swot.key,
          indice: swotData.indice,
          porcentagemForca: swotData.porcentagemForca,
          porcentagemFraqueza: swotData.porcentagemFraqueza,
          porcentagemOportunidade: swotData.porcentagemOportunidade,
          porcentagemAmeaca: swotData.porcentagemAmeaca,
          quantidadeForca: swotData.quantidadeForca,
          quantidadeFraqueza: swotData.quantidadeFraqueza,
          quantidadeOportunidade: swotData.quantidadeOportunidade,
          quantidadeAmeaca: swotData.quantidadeAmeaca,
          forcas: [],
          fraquezas: [],
          oportunidades: [],
          ameacas: []
        };
        objSwot.forcas = swotData.forca.map((item) => ({
          swotServicoId: item.swotServicoId,
          servicoId: item.servicoId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          servico: item.servico
        }));
        objSwot.fraquezas = swotData.fraqueza.map((item) => ({
          swotServicoId: item.swotServicoId,
          servicoId: item.servicoId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          servico: item.servico
        }));
        objSwot.oportunidades = swotData.oportunidade.map((item) => ({
          swotServicoId: item.swotServicoId,
          servicoId: item.servicoId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          servico: item.servico
        }));
        objSwot.ameacas = swotData.ameaca.map((item) => ({
          swotServicoId: item.swotServicoId,
          servicoId: item.servicoId,
          gravidade: item.gravidade,
          urgencia: item.urgencia,
          tendencia: item.tendencia,
          gut: item.gut,
          tipo: item.tipo,
          id: item.id,
          key: item.key,
          servico: item.servico
        }));
        setSwotServicoRelatorio(objSwot);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [AddCruzamentoServico, setAddCruzamentoServico] = useState("")

  const AdicionarCruzamentoServico = async () => {
    const token = Cookies.get("Token");
    setLoading(true);
    const data = {
      swotServicoKey: SwotServicoAtualKey,
      forcaFraqueza: AddCruzamentoServico.forcaFraqueza,
      capacidadeGTIForcaFraqueza: AddCruzamentoServico.capacidadeGTIForcaFraqueza,
      oportunidadeAmeaca: AddCruzamentoServico.oportunidadeAmeaca,
      capacidadeGTIOportunidadeAmeaca: AddCruzamentoServico.capacidadeGTIOportunidadeAmeaca,
      tipoEstrategia: AddCruzamentoServico.tipoEstrategia,
      recomendacao: AddCruzamentoServico.recomendacao,
    };
    return axios({
      url: baseurl + "SwotServico/AdicionarCruzamento",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then((response) => {
        ListaCruzamentoServico()
        setSuccess("Adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
        setAddCruzamentoServico({
          forcaFraqueza: "",
          capacidadeGTIForcaFraqueza: "",
          oportunidadeAmeaca: "",
          capacidadeGTIOportunidadeAmeaca: "",
          tipoEstrategia: "",
          recomendacao: "",
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const [CruzamentoServico, setCruzamentoServico] = useState("")

  const ListaCruzamentoServico = useCallback(async () => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "SwotServico/Cruzamento?key=" + SwotServicoAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setCruzamentoServico(response.data);
        return Promise.resolve()
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ExcluirCruzamentoServico = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "SwotServico/ExcluirCruzamento?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        ListaCruzamentoServico()
        setSuccess("Cruzamento excluído com sucesso!");
        setCruzamentoServicoKey("")
        setModalExcluirCruzamento(false)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const [AreaSwotServico, setAreaSwotServico] = useState([]);

  const ListaAreaSwotServico = useCallback(async (key) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "SwotServico/ListaArea?key=" + key + "&empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setAreaSwotServico(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const CriarCiclo = async (event) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    setLoading(true);
    let dataInicialISO = '';
    let dataFinalISO = '';
    try {
      if (CicloCadastro === "") {
        setLoading(false)
        setError("Formulário vazio.");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof CicloCadastro.descricao === "undefined" || CicloCadastro.descricao === "") {
        setLoading(false)
        setError("Descrição não informada");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof CicloCadastro.observacao === "undefined" || CicloCadastro.observacao === "") {
        setLoading(false)
        setError("Observação não informada");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof CicloCadastro.dataInicial === "undefined" || CicloCadastro.dataInicial === "undefined") {
        setLoading(false)
        setError("Data inicial não informada");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof CicloCadastro.dataFinal === "undefined" || CicloCadastro.dataFinal === "undefined") {
        setLoading(false)
        setError("Data final não informada");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
      if (typeof CicloCadastro.dataInicial != "undefined" && CicloCadastro.dataInicial != "") {
        dataInicialISO = new Date(CicloCadastro.dataInicial).toISOString();
      }
      if (typeof CicloCadastro.dataFinal != "undefined" && CicloCadastro.dataFinal != "") {
        dataFinalISO = new Date(CicloCadastro.dataFinal).toISOString();
      }
    } catch (error) {
    }
    const data = {
      EmpresaKey: EmpresaKey,
      descricao: CicloCadastro.descricao,
      observacao: CicloCadastro.observacao,
      dataInicial: dataInicialISO,
      dataFinal: dataFinalISO,
      naoAlterarBSCSwot: CicloCadastro.naoAlterarBSCSwot,
      naoAlterarBSCSwotServico: CicloCadastro.naoAlterarBSCSwotServico,
      idExterno: CicloCadastro.idExterno
    };
    return axios({
      url: baseurl + "CicloDemanda/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCiclosConsulta(1, 10)
        setSuccess("Ciclo cadastrado com sucesso!");
        setCicloCadastro({})
        setModalCriarCiclo(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaSistemaCapacidade = async () => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "CapacidadeNegocioDemandaSistema/Listar?capacidadeNegocioDemandaKey=" + CapacidadeAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setSistemaCapacidade(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const CadastrarPlanoNegocio = async (event, currentPage) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    setLoading(true);
    if (PlanoNegocio === "") {
      setLoading(false)
      setError("Formulário vazio.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof PlanoNegocio.indicador === "undefined" || PlanoNegocio.indicador === "") {
      setLoading(false)
      setError("Indicador não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof PlanoNegocio.tipo === "undefined" || PlanoNegocio.tipo === "0") {
      setLoading(false)
      setError("Tipo não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      indicador: PlanoNegocio.indicador,
      valor: PlanoNegocio.valor,
      tipo: PlanoNegocio.tipo,
      ativo: true,
      custo: PlanoNegocio.custo,
      data: PlanoNegocio.data,
      pessoa: PlanoNegocio.pessoa,
      avaliacaoKey: PlanoNegocio.avaliacaoKey,
      idExterno: PlanoNegocio.idExterno
    };
    return axios({
      url: baseurl + "PlanoNegocio/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaPlanoNegocioConsulta(currentPage, 10)
        setSuccess("Plano de Negócios cadastrado com sucesso!");
        setOpenModal(false)
        setPlanoNegocio({
          avaliacao: "",
          indicador: "",
          valor: "",
          tipo: "",
          ativo: "",
          planoNegocioPaiKey: "",
          custo: false,
          data: false,
          pessoa: false
        })
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaPlanoNegocio = useCallback(async (ativo) => {
    let objPlano = {};
    let arrayPlano = [];
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "PlanoNegocio/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=" + ativo,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const plano = eval(response.data);
        plano.forEach((e) => {
          objPlano = {
            indicador: e.indicador,
            valor: e.valor,
            tipo: e.tipo,
            custo: e.custo,
            data: e.data,
            pessoa: e.pessoa,
            avaliacaoPlanoNegocio: e.avaliacaoPlanoNegocio,
            avaliacaoPlanoNegocioId: e.avaliacaoPlanoNegocioId,
            ativo: e.ativo,
            empresa: e.empresa,
            key: e.key,
            idExterno: e.idExterno
          };
          arrayPlano.push(objPlano);
        });
        setPlanoNegocios(arrayPlano);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [totalRegistrosPlanoNegocio, setTotalRegistrosPlanoNegocio] = useState(0);

  const ListaPlanoNegocioConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "PlanoNegocio/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=N&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        indicador: e.indicador,
        valor: e.valor,
        tipo: e.tipo,
        custo: e.custo,
        data: e.data,
        pessoa: e.pessoa,
        avaliacaoPlanoNegocio: e.avaliacaoPlanoNegocio,
        avaliacaoPlanoNegocioId: e.avaliacaoPlanoNegocioId,
        ativo: e.ativo,
        empresa: e.empresa,
        key: e.key,
        idExterno: e.idExterno
      }));
      setPlanoNegociosConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosPlanoNegocio(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroPlanoNegocio, setFiltroPlanoNegocio] = useState([]);
  const [totalRegistrosFiltroPlanoNegocio, setTotalRegistrosFiltroPlanoNegocio] = useState(0);

  const ListaFiltroPlanoNegocio = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "PlanoNegocio/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroPlanoNegocio(response.data.data);
        setTotalRegistrosFiltroPlanoNegocio(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ListaTipoPlanoNegocio = useCallback(async () => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "PlanoNegocio/ListarTipos",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const plano = eval(response.data);
        setTipoPlanoNegocio(plano);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const EditarPlanoNegocio = async (currentPage) => {
    const token = Cookies.get("Token");
    setLoading(true)
    if (typeof EdicaoPlanoNegocio.indicador === "undefined" || EdicaoPlanoNegocio.indicador === "") {
      setLoading(false)
      setError("Indicador não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      avaliacaoKey: EdicaoPlanoNegocio.avaliacaoPlanoNegocio?.key || "0",
      indicador: EdicaoPlanoNegocio.indicador,
      valor: EdicaoPlanoNegocio.valor,
      tipo: EdicaoPlanoNegocio.tipo,
      planoNegocioPaiKey: EdicaoPlanoNegocio.planoNegocioPaiKey,
      ativo: true,
      custo: EdicaoPlanoNegocio.custo,
      data: EdicaoPlanoNegocio.data,
      pessoa: EdicaoPlanoNegocio.pessoa,
      idExterno: EdicaoPlanoNegocio.idExterno,
      empresa: EmpresaKey,
    };
    return axios({
      url: baseurl + "PlanoNegocio/Alterar?key=" + PlanoNegocioAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaPlanoNegocioConsulta(currentPage, 10);
        setSuccess("Plano de Negócio editado com sucesso!");
        setModalEditarPlanoNegocio(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirPlanoNegocio = async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "PlanoNegocio/Deletar?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaPlanoNegocioConsulta(currentPage, 10)
        setSuccess("Plano de Negócio excluído com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirPlanoNegocio(false)
      })
      .catch((error) => {
        setLoading(false)
        setModalExcluirPlanoNegocio(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        setError("Não foi possível excluir o item.")
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const StatusPlanoNegocio = async (key, status, currentPage) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "PlanoNegocio/Ativo?key=" + key + "&status=" + status,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        ListaPlanoNegocioConsulta(currentPage, 10);
        if (status) {
          setSuccess("Plano de negócio ativado com sucesso.")
        } else {
          setSuccess("Plano de negócio inativado com sucesso.")
        }
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const AtualizarPlanoNegocio = async (demandaKey, planoNegocioKey, valor) => {
    const token = Cookies.get("Token");
    const data = {
      demandaKey: demandaKey,
      planoNegocioKey: planoNegocioKey,
      valor: valor
    };
    return axios({
      url: baseurl + "Demanda/AtualizarPlanoNegocio",
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      data: data
    })
      .then((response) => {
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const CadastrarPlanoNegocioAvaliacao = async (event) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    setLoading(true);
    if (typeof PlanoNegocioAvaliacao === "undefined" || PlanoNegocioAvaliacao === "") {
      setLoading(false)
      setError("Descrição não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      descricao: PlanoNegocioAvaliacao
    };
    return axios({
      url: baseurl + "PlanoNegocio/AdicionarAvaliacao",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaPlanoNegocioAvaliacao()
        setSuccess("Avaliação cadastrada com sucesso!");
        setPlanoNegocioAvaliacao("")
        setOpenModal(false)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setError(error.response.data)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const [EdicaoAvaliacao, setEdicaoAvaliacao] = useState({})

  const AlterarPlanoNegocioAvaliacao = async () => {
    const token = Cookies.get("Token");
    const data = {
      avaliacaoPlanoNegocioKey: AvaliacaoAtualKey,
      descricao: EdicaoAvaliacao.descricao,
      empresaKey: EmpresaKey
    };
    return axios({
      url: baseurl + "PlanoNegocio/AlterarAvaliacao?key=" + AvaliacaoAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data
    })
      .then((response) => {
        ListaPlanoNegocioAvaliacao();
        setSuccess("Avaliação editada com sucesso!");
        setModalEditarAvaliacao(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaPlanoNegocioAvaliacao = useCallback(async () => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "AvaliacaoPlanoNegocio/ListarAvaliacao?empresaKey=" + EmpresaKey + "&somenteAtivas=N",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setAvaliacao(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [totalRegistrosAvaliacao, setTotalRegistrosAvaliacao] = useState(0);
  const [AvaliacaoConsulta, setAvaliacaoConsulta] = useState([])

  const ListaAvaliacaoConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: `${baseurl}AvaliacaoPlanoNegocio/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const plano = eval(response.data.data);
      const arrayArea = plano.map((e) => ({
        descricao: e.descricao,
        key: e.key,
        ativo: e.ativo
      }));
      setAvaliacaoConsulta((prevAreas) => {
        const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
        return isEqual ? prevAreas : arrayArea;
      });
      setTotalRegistrosAvaliacao(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`);
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false);
        return;
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`);
      });
      setTimeout(() => {
        setError("");
      }, 3000);
      return Promise.reject(error);
    }
  })

  const [filtroAvaliacao, setFiltroAvaliacao] = useState([]);
  const [totalRegistrosFiltroAvaliacao, setTotalRegistrosFiltroAvaliacao] = useState(0);

  const ListaFiltroAvaliacao = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "AvaliacaoPlanoNegocio/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroAvaliacao(response.data.data);
        setTotalRegistrosFiltroAvaliacao(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const InativarAvaliacao = async (key, status) => {
    setLoading(true);
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "AvaliacaoPlanoNegocio/AtivoAvaliacao?key=" + key + "&status=" + status,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setAvaliacaoConsulta(prev =>
          prev.map(item =>
            item.key === key ? { ...item, ativo: status } : item
          )
        );
        setSuccess("Avaliação ativada/inativada com sucesso!");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  };

  const [AvaliacaoCadastro, setAvaliacaoCadastro] = useState("");

  const CadastrarAvaliacao = async (event, currentPage) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    setLoading(true);
    if (typeof AvaliacaoCadastro.descricao === "undefined" || AvaliacaoCadastro.descricao === "") {
      setLoading(false)
      setError("Descrição não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      descricao: AvaliacaoCadastro.descricao,
    };
    return axios({
      url: baseurl + "AvaliacaoPlanoNegocio/AdicionarAvaliacao",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaAvaliacaoConsulta(currentPage, 10)
        setSuccess("Avaliação cadastrada com sucesso!");
        setOpenModal(false)
        setAvaliacaoCadastro({
          descricao: "",
        })
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }
  const [AvaliacaoEdicao, setAvaliacaoEdicao] = useState("");

  const EditarAvaliacao = async (currentPage) => {
    const token = Cookies.get("Token");
    setLoading(true)
    if (typeof AvaliacaoEdicao.descricao === "undefined" || AvaliacaoEdicao.descricao === "") {
      setLoading(false)
      setError("Descrição não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      avaliacaoPlanoNegocioKey: AvaliacaoEdicao.avaliacaoPlanoNegocioKey || "0",
      descricao: AvaliacaoEdicao.descricao,
    };
    return axios({
      url: baseurl + "AvaliacaoPlanoNegocio/AlterarAvaliacao?key=" + AvaliacaoAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaAvaliacaoConsulta(currentPage, 10);
        setSuccess("Avaliação editada com sucesso!");
        setModalEditarAvaliacao(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirAvaliacao = async (currentPage, key) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "AvaliacaoPlanoNegocio/DeletarAvaliacao?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaAvaliacaoConsulta(currentPage, 10)
        setSuccess("Avaliação excluída com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirAvaliacao(false)
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setError("Não foi possível excluir o item.")
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }


  const ExcluirPlanoNegocioAvaliacao = async (key) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "PlanoNegocio/DeletarAvaliacao?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaPlanoNegocioAvaliacao()
        setSuccess("Avaliação excluída com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirAvaliacao(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        setError("Não foi possível excluir o item.")
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const ListaPlanoDemanda = useCallback(async () => {
    let array = [];
    let obj = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ListarPlanoNegocio?demandaKey=" + DemandaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          obj = {
            demandaId: e.demandaId,
            planoNegocioId: e.planoNegocioId,
            valor: e.valor,
            planoNegocio: e.planoNegocio,
            id: e.id,
            key: e.key,
          };
          array.push(obj);
        });
        setPlanoDemanda(array.reverse());
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ExcluirPlanoDemanda = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ExcluirPlanoNegocio?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        ListaPlanoDemanda();
        setSuccess(response.data);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ObterDiretrizesItemsDoCiclo = useCallback(async (ciclo) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "BSC/ObterDiretrizesItemsDoCiclo?empresaKey=" + EmpresaKey + "&cicloDemandaKey=" + ciclo,
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setDiretrizesItemsDoCiclo(response.data);
        return Promise.resolve(response.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        return Promise.reject()
      })
  })

  const ObterGutSwot = async (areaKey, cicloDemandaKey, capacidadeKey) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/ObterGutCapacidade?areaKey=" + areaKey + "&cicloDemandaKey=" + cicloDemandaKey + "&capacidadeKey=" + capacidadeKey,
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setGutSwot(response.data);
        return Promise.resolve(response.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        else {
          setLoading(false);
        }
        return Promise.reject()
      })
  }

  const AdicionarCapacidadeNegocio = async (capacidadeKey, areaKey) => {
    const token = Cookies.get("Token");
    setLoading(true);
    const data = {
      demandaKey: DemandaAtualKey,
      capacidadeNegocioKey: capacidadeKey,
      areaKey: areaKey,
    };
    return axios({
      url: baseurl + "Demanda/AdicionarCapacidadeNegocio",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCapacidadeNegocio()
        setSuccess("Capacidade adicionada com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaCapacidadeNegocio = async () => {
    let array = [];
    let obj = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ListarCapacidadeNegocio?demandaKey=" + DemandaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          obj = {
            empresaId: e.empresaId,
            capacidadeNegocioDemandaId: e.capacidadeNegocioDemandaId,
            demanda: e.demanda,
            capacidadeNegocioDemanda: e.capacidadeNegocioDemanda,
            id: e.id,
            key: e.key,
          };
          array.push(obj);
        });
        setCapacidadeDemanda(array);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirCapacidadeNegocio = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ExcluirCapacidadeNegocio?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        ListaCapacidadeNegocio();
        setSuccess("Capacidade excluída com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaBSC = useCallback(async (key) => {
    if (!key || !EmpresaKey) return;
    setLoading(true);

    const token = Cookies.get("Token");

    try {
      const response = await axios({
        url: `${baseurl}BSC/Listar?empresaKey=${EmpresaKey}&cicloDemandaKey=${key}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response.data || [];
      const array = data.map((e) => ({
        alteracaoDataHora: e.alteracaoDataHora,
        key: e.key,
        cicloDemanda: e.cicloDemanda,
        cicloDemandaId: e.cicloDemandaId,
        criacaoDataHora: e.criacaoDataHora,
        descricao: e.descricao,
        empresaId: e.empresaId,
        id: e.id,
        padrao: e.padrao,
      }));

      setBSCs(array);
      return array;

    } catch (error) {
      if (error.response?.status === 401) {
        setError("Sua sessão expirou, faça login novamente");
        setTimeout(() => setError(""), 3000);
        setAuth(false);
        return;
      }

      error.response?.data?.forEach((er) => {
        setError(`${er.campo}: ${er.mensagem}`);
      });

      setTimeout(() => setError(""), 3000);
      throw error;

    } finally {
      setLoading(false);
    }
  }, [EmpresaKey]);

  const [totalRegistrosBSC, setTotalRegistrosBSC] = useState(0);

  const ListaBSCConsulta = useCallback(async (key, posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: baseurl + "BSC/ListarConsulta?empresaKey=" + `${EmpresaKey}` + "&cicloDemandaKey=" + key + "&posicao=" + posicao + "&quantidade=" + qtd,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayCapacidades = user.map((e) => ({
        alteracaoDataHora: e.alteracaoDataHora,
        key: e.key,
        cicloDemanda: e.cicloDemanda,
        cicloDemandaId: e.cicloDemandaId,
        criacaoDataHora: e.criacaoDataHora,
        descricao: e.descricao,
        empresaId: e.empresaId,
        id: e.id,
        padrao: e.padrao
      }));
      setBSCsConsulta(prevCapacidades => {
        const isEqual = JSON.stringify(prevCapacidades) === JSON.stringify(arrayCapacidades);
        return isEqual ? prevCapacidades : arrayCapacidades;
      });
      setTotalRegistrosBSC(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroBSC, setFiltroBSC] = useState([]);
  const [totalRegistrosFiltroBSC, setTotalRegistrosFiltroBSC] = useState(0);

  const ListaFiltroBSC = useCallback(async (cicloDemandaKey, filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "BSC/ListarComFiltro?empresaKey=" + EmpresaKey + "&cicloDemandaKey=" + cicloDemandaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroBSC(response.data.data);
        setTotalRegistrosFiltroBSC(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const CadastrarBSC = async (event) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    setLoading(true);
    if (typeof CadastroBSC.cicloDemandaKey === "undefined" || CadastroBSC.cicloDemandaKey === "") {
      setLoading(false)
      setError("Informe um ciclo na tela anterior");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof CadastroBSC.descricao === "undefined" || CadastroBSC.descricao.trim() === "") {
      setLoading(false)
      setError("Descrição não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      cicloDemandaKey: CadastroBSC.cicloDemandaKey,
      descricao: CadastroBSC.descricao,
    };
    return axios({
      url: baseurl + "BSC/Criar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaBSCConsulta(CadastroBSC.cicloDemandaKey, 1, 10)
        setSuccess("BSC cadastrado com sucesso!");
        setCadastroBSC([])
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const BSCPadrao = async (key, cicloKey, currentPage) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "BSC/DefinirPadrao?BSCKey=" + key,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        ListaBSCConsulta(cicloKey, currentPage, 10)
        setSuccess("Atualizado com sucesso.")
        setModalBSCPadrao(false)
        setModalEditarBSC(false)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const AdicionarCompetenciaItem = async (key, quantidade) => {
    const token = Cookies.get("Token");
    setLoading(true);
    const data = {
      demandaKey: DemandaAtualKey,
      competenciaKey: key,
      quantidade: quantidade
    };
    return axios({
      url: baseurl + "Demanda/AdicionarCompetencia",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCompetenciaItem()
        setSuccess("Competência adicionada com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaCompetenciaItem = async () => {
    let array = [];
    let obj = {};
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ListarCompetencia?demandaKey=" + DemandaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          obj = {
            quantidade: e.quantidade,
            competencia: e.competencia,
            id: e.id,
            key: e.key,
          };
          array.push(obj);
        });
        setCompetenciaDemanda(array);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirCompetenciaItem = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Demanda/ExcluirCompetencia?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        ListaCompetenciaItem();
        setSuccess("Competência excluída com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ListaDemandaPorCiclo = useCallback(async (cicloKey) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Demanda/ListarPorCiclo?cicloKey=" + cicloKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setDemandaPorCiclo(response.data)
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const AdicionarCruzamento = async () => {
    const token = Cookies.get("Token");
    setLoading(true);
    const data = {
      swotKey: SwotAtualKey,
      forcaFraqueza: AddCruzamento.forcaFraqueza,
      capacidadeGTIForcaFraqueza: AddCruzamento.capacidadeGTIForcaFraqueza,
      oportunidadeAmeaca: AddCruzamento.oportunidadeAmeaca,
      capacidadeGTIOportunidadeAmeaca: AddCruzamento.capacidadeGTIOportunidadeAmeaca,
      tipoEstrategia: AddCruzamento.tipoEstrategia,
      recomendacao: AddCruzamento.recomendacao,
    };
    return axios({
      url: baseurl + "Swot/AdicionarCruzamento",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then((response) => {
        ListaCruzamento()
        setSuccess("Adicionado com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
        setAddCruzamento({
          forcaFraqueza: "",
          capacidadeGTIForcaFraqueza: "",
          oportunidadeAmeaca: "",
          capacidadeGTIOportunidadeAmeaca: "",
          tipoEstrategia: "",
          recomendacao: "",
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaCruzamento = useCallback(async () => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/Cruzamento?key=" + SwotAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setCruzamento(response.data);
        return Promise.resolve()
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ExcluirCruzamento = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Swot/ExcluirCruzamento?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        ListaCruzamento()
        setSuccess("Cruzamento excluído com sucesso!");
        setCruzamentoKey("")
        setModalExcluirCruzamento(false)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const CadastrarArea = async (event, currentPage, areaKey) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    if (typeof CadastroArea.descricao === "undefined" || CadastroArea.descricao === "") {
      setLoading(false)
      setError("Descrição não informada.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      EmpresaKey: EmpresaKey,
      descricao: CadastroArea.descricao,
      areaPaiKey: areaKey,
      itens: ItensArea,
      idExterno: CadastroArea.idExterno
    };
    return axios({
      url: baseurl + "Area/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaAreaConsulta(currentPage, 10)
        setSuccess("Área cadastrada com sucesso!");
        setCadastroArea({
          descricao: ""
        })
        setItensArea([])
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setError(error.response.data)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaArea = useCallback(async () => {
    let objArea = {};
    let arrayArea = [];
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Area/Listar?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          objArea = {
            descricao: e.descricao,
            key: e.key,
            id: e.id,
            areaPai: e.areaPai,
            idExterno: e.idExterno
          };
          arrayArea.push(objArea);
        });
        setAreas(arrayArea);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [totalRegistrosArea, setTotalRegistrosArea] = useState(0);

  const ListaAreaConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: `${baseurl}Area/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayArea = user.map((e) => ({
        descricao: e.descricao,
        key: e.key,
        id: e.id,
        areaPai: e.areaPai,
        idExterno: e.idExterno
      }));
      setAreasConsulta(arrayArea);
      setTotalRegistrosArea(response.data.totalRegistros)
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  });

  const [filtroArea, setFiltroArea] = useState([]);
  const [totalRegistrosFiltroArea, setTotalRegistrosFiltroArea] = useState(0);

  const ListaFiltroArea = useCallback(async (filtro, posicao, qtd) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Area/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + qtd,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroArea(response.data.data);
        setTotalRegistrosFiltroArea(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ListaAreaPorCiclo = useCallback(async (cicloId) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Area/listarPorCiclo?empresaKey=" + EmpresaKey + "&cicloId=" + cicloId,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setAreaPorCiclo(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [AreaTimes, setAreaTimes] = useState([]);

  const RetornaAreaTimes = useCallback(async (key) => {
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Area/ObterTimes?key=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setAreaTimes(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const EditarArea = async (currentPage, areaKey) => {
    const token = Cookies.get("Token");
    const data = {
      empresaKey: EmpresaKey,
      descricao: EdicaoArea.descricao,
      areaPaiKey: areaKey,
      itens: EdicaoArea.itens,
      idExterno: EdicaoArea.idExterno,
      empresaKey: EmpresaKey
    };
    return axios({
      url: baseurl + "Area/Alterar?key=" + AreaAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaAreaConsulta(currentPage, 10)
        setSuccess("Área editada com sucesso!");
        setModalEditarArea(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirArea = async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "Area/Deletar?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaAreaConsulta(currentPage, 10)
        setSuccess("Área excluída com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirArea(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        setError("Área não pôde ser excluída, pois pertence a um SWOT.")
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const AdicionarItensArea = async (pessoaKey, cargoKey) => {
    const token = Cookies.get("Token");
    setLoading(true);
    if (cargoKey && !pessoaKey) {
      setLoading(false)
      setError("Pessoa não informada.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    } else if (pessoaKey && !cargoKey) {
      setLoading(false)
      setError("Cargo não informado.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      areaKey: AreaAtualKey,
      pessoaKey: pessoaKey,
      cargoKey: cargoKey
    };
    return axios({
      url: baseurl + "Area/AdicionarItem",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaItensArea()
        setSuccess("Item adicionado com sucesso!");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaItensArea = useCallback(async () => {
    let objArea = {};
    let arrayArea = [];
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Area/ListarItem?areaKey=" + AreaAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          objArea = {
            pessoa: e.pessoa,
            cargo: e.cargo,
            key: e.key
          };
          arrayArea.push(objArea);
        });
        setAreaItens(arrayArea);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const ExcluirItensArea = async (key) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "Area/ExcluirItem?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaItensArea()
        setSuccess("Item excluído com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const CadastrarCargo = async (event, currentPage) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    setLoading(true);
    if (CadastroCargo === "") {
      setLoading(false)
      setError("Formulário vazio.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof CadastroCargo.descricao === "undefined" || CadastroCargo.descricao === "") {
      setLoading(false)
      setError("Descrição não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      descricao: CadastroCargo.descricao,
      competencias: CadastroCargo.competencias,
      ativo: true,
      idExterno: CadastroCargo.idExterno
    };
    return axios({
      url: baseurl + "Cargo/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCargoConsulta(currentPage, 10)
        setSuccess("Cargo cadastrado com sucesso!");
        setCadastroCargo({
          descricao: ""
        })
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setError(error.response.data)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaCargo = useCallback(async () => {
    let obj = {};
    let array = [];
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Cargo/Listar?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          obj = {
            descricao: e.descricao,
            key: e.key,
            id: e.id,
            idExterno: e.idExterno,
          };
          array.push(obj);
        });
        setCargos(array);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [totalRegistrosCargo, setTotalRegistrosCargo] = useState(0);

  const ListaCargoConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: `${baseurl}Cargo/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      setLoading(false);
      const user = eval(response.data.data);
      const arrayCargo = user.map((e) => ({
        descricao: e.descricao,
        key: e.key,
        id: e.id,
        idExterno: e.idExterno
      }));
      setCargosConsulta(prevCargos => {
        const isEqual = JSON.stringify(prevCargos) === JSON.stringify(arrayCargo);
        return isEqual ? prevCargos : arrayCargo;
      });
      setTotalRegistrosCargo(response.data.totalRegistros)
    } catch (error) {
      // setLoading(false);
      // if (error.response.status === 401) {
      //   setError(`Sua sessão expirou, faça login novamente`)
      //   setTimeout(() => {
      //     setError("");
      //   }, 3000);
      //   setAuth(false)
      //   return
      // }
      // error.response.data.map((er) => {
      //   setError(`${er.campo}: ${er.mensagem}`)
      // })
      console.log(error);
      return Promise.reject(error);
    }
  })

  const [filtroCargo, setFiltroCargo] = useState([]);
  const [totalRegistrosFiltroCargo, setTotalRegistrosFiltroCargo] = useState(0);

  const ListaFiltroCargo = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Cargo/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroCargo(response.data.data);
        setTotalRegistrosFiltroCargo(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const EditarCargo = async (currentPage) => {
    const token = Cookies.get("Token");
    setLoading(true)
    const data = {
      empresaKey: EmpresaKey,
      descricao: EdicaoCargo.descricao,
      competencias: EdicaoCargo.competencias,
      ativo: true,
      idExterno: EdicaoCargo.idExterno,
      empresaKey: EmpresaKey
    };
    return axios({
      url: baseurl + "Cargo/Alterar?key=" + CargoAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCargoConsulta(currentPage, 10);
        setSuccess("Cargo editado com sucesso!");
        setModalEditarCargo(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirCargo = async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "Cargo/Deletar?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaCargoConsulta(currentPage, 10)
        setSuccess("Cargo excluído com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirCargo(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const CadastrarCompetencia = async (event, currentPage) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    setLoading(true);
    if (CadastroCompetencia === "") {
      setLoading(false)
      setError("Formulário vazio.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof CadastroCompetencia.descricao === "undefined" || CadastroCompetencia.descricao === "") {
      setLoading(false)
      setError("Descrição não informada");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      descricao: CadastroCompetencia.descricao,
      ativo: true,
      idExterno: CadastroCompetencia.idExterno
    };
    return axios({
      url: baseurl + "Competencia/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCompetenciaConsulta(currentPage, 10)
        setSuccess("Competência cadastrada com sucesso!");
        setCadastroCompetencia({
          descricao: ""
        })
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setError(error.response.data)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaCompetencia = useCallback(async () => {
    let obj = {};
    let array = [];
    const token = Cookies.get("Token");
    setLoading(true)
    return axios({
      url: baseurl + "Competencia/Listar?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const user = eval(response.data);
        user.forEach((e) => {
          obj = {
            descricao: e.descricao,
            key: e.key,
            ativo: e.ativo,
            id: e.id,
            idExterno: e.idExterno
          };
          array.push(obj);
        });
        setCompetencias(array);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })
  const [totalRegistrosCompetencia, setTotalRegistrosCompetencia] = useState(0);

  const ListaCompetenciaConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: `${baseurl}Competencia/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      setLoading(false);
      const user = eval(response.data.data);
      const arrayArea = user.map((e) => ({
        descricao: e.descricao,
        ativo: e.ativo,
        key: e.key,
        id: e.id,
        idExterno: e.idExterno
      }));
      setCompetenciasConsulta(prevAreas => {
        const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
        return isEqual ? prevAreas : arrayArea;
      });
      setTotalRegistrosCompetencia(response.data.totalRegistros)
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  });

  const [filtroCompetencia, setFiltroCompetencia] = useState([]);
  const [totalRegistrosFiltroCompetencia, setTotalRegistrosFiltroCompetencia] = useState(0);

  const ListaFiltroCompetencia = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Competencia/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroCompetencia(response.data.data);
        setTotalRegistrosFiltroCompetencia(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const EditarCompetencia = async (currentPage) => {
    const token = Cookies.get("Token");
    setLoading(true)
    const data = {
      empresaKey: EmpresaKey,
      descricao: EdicaoCompetencia.descricao,
      ativo: EdicaoCompetencia.ativo,
      idExterno: EdicaoCompetencia.idExterno,
      empresaKey: EmpresaKey
    };
    return axios({
      url: baseurl + "Competencia/Alterar?key=" + CompetenciaAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCompetenciaConsulta(currentPage, 10);
        setSuccess("Competência editada com sucesso!");
        setModalEditarCompetencia(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const InativarCompetencia = async (key, status) => {
    setLoading(true);
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Competencia/Ativo?key=" + key + "&status=" + status,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setCompetenciasConsulta(prev =>
          prev.map(item =>
            item.key === key ? { ...item, ativo: status } : item
          )
        );
        setSuccess("Competência ativada/inativada com sucesso!");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  };

  const ExcluirCompetencia = async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "Competencia/Deletar?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaCompetenciaConsulta(currentPage, 10)
        setSuccess("Competência excluída com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirCompetencia(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const [CompetenciaCargo, setCompetenciaCargo] = useState([]);

  const AdicionarCargoCompetencia = async (key) => {
    const token = Cookies.get("Token");
    const data = {
      competenciaKey: key,
      cargoKey: CargoAtualKey,
    };
    return axios({
      url: baseurl + "Cargo/AdicionarCompetencia",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaCargoCompetencia()
        setSuccess("Competência adicionada com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaCargoCompetencia = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Cargo/ListarCompetencia?cargoKey=" + CargoAtualKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setCompetenciaCargo(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const ExcluirCargoCompetencia = async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Cargo/ExcluirCompetencia?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        ListaCargoCompetencia();
        setSuccess("Competência excluída com sucesso.");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false);
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const CadastrarPessoa = async (event, currentPage) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    setLoading(true);
    if (CadastroPessoa === "") {
      setLoading(false)
      setError("Formulário vazio.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof CadastroPessoa.nome === "undefined" || CadastroPessoa.nome === "") {
      setLoading(false)
      setError("Nome não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof CadastroPessoa.cargoKey === "undefined" || CadastroPessoa.cargoKey === 0) {
      setLoading(false)
      setError("Cargo não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      nome: CadastroPessoa.nome,
      cargoKey: CadastroPessoa.cargoKey,
      ativo: true,
      idExterno: CadastroPessoa.idExterno
    };
    return axios({
      url: baseurl + "Pessoa/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaPessoaConsulta(currentPage, 10)
        setSuccess("Pessoa cadastrada com sucesso!");
        setCadastroPessoa({
          nome: "",
          cargoKey: 0
        })
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setError(error.response.data)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaPessoa = async () => {
    let obj = {};
    let array = [];
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Pessoa/Listar?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          obj = {
            nome: e.nome,
            cargo: e.cargo,
            key: e.key,
            id: e.id,
          };
          array.push(obj);
        });
        setPessoas(array);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  }

  const [totalRegistrosPessoa, setTotalRegistrosPessoa] = useState(0);

  const ListaPessoaConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: `${baseurl}Pessoa/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      setLoading(false);
      const user = eval(response.data.data);
      const arrayArea = user.map((e) => ({
        nome: e.nome,
        cargo: e.cargo,
        key: e.key,
        id: e.id,
        idExterno: e.idExterno
      }));
      setPessoasConsulta(prevAreas => {
        const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
        return isEqual ? prevAreas : arrayArea;
      });
      setTotalRegistrosPessoa(response.data.totalRegistros)
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  });

  const [filtroPessoa, setFiltroPessoa] = useState([]);
  const [totalRegistrosFiltroPessoa, setTotalRegistrosFiltroPessoa] = useState(0);

  const ListaFiltroPessoa = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Pessoa/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroPessoa(response.data.data);
        setTotalRegistrosFiltroPessoa(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const ListaPessoaPorCargo = useCallback(async (key) => {
    let obj = {};
    let array = [];
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Pessoa/ListarPorCargo?empresaKey=" + EmpresaKey + "&cargoKey=" + key,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const user = eval(response.data);
        user.forEach((e) => {
          obj = {
            nome: e.nome,
            cargo: e.cargo,
            key: e.key,
            id: e.id,
          };
          array.push(obj);
        });
        setPessoasPorCargo(array);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
          setTimeout(() => {
            setError("");
          }, 3000);
        })
        return Promise.reject();
      });
  })

  const EditarPessoa = async (key, currentPage) => {
    const token = Cookies.get("Token");
    setLoading(true)
    const data = {
      empresaKey: EmpresaKey,
      nome: EdicaoPessoa.nome,
      cargoKey: key,
      ativo: true,
      idExterno: EdicaoPessoa.idExterno,
      empresaKey: EmpresaKey
    };
    return axios({
      url: baseurl + "Pessoa/Alterar?key=" + PessoaAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaPessoaConsulta(currentPage, 10);
        setSuccess("Pessoa editada com sucesso!");
        setModalEditarPessoa(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirPessoa = async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "Pessoa/Deletar?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaPessoaConsulta(currentPage, 10)
        setSuccess("Pessoa excluída com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirPessoa(false)
      })
      .catch((error) => {
        setModalExcluirPessoa(false)
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const CadastrarSistema = async (event, currentPage) => {
    event.preventDefault();
    const token = Cookies.get("Token");
    let dataInicialISO = '';
    let dataFinalISO = '';
    if (typeof CadastroSistema.dataInicialVersao != "undefined" && CadastroSistema.dataInicialVersao != "") {
      dataInicialISO = new Date(CadastroSistema.dataInicialVersao).toISOString();
    }
    if (typeof CadastroSistema.dataFinalVersao != "undefined" && CadastroSistema.dataFinalVersao != "") {
      dataFinalISO = new Date(CadastroSistema.dataFinalVersao).toISOString();
    }
    if (typeof CadastroSistema.nome === "undefined" || CadastroSistema.nome === "") {
      setLoading(false)
      setError("Nome não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      EmpresaKey: EmpresaKey,
      descricao: CadastroSistema.descricao,
      fornecedorKey: CadastroSistema.fornecedorKey,
      nome: CadastroSistema.nome,
      versao: CadastroSistema.versao,
      dataInicialVersao: dataInicialISO,
      dataFinalVersao: dataFinalISO,
      idExterno: CadastroSistema.idExterno,
      camadaImpactoNegocio: CadastroSistema.camadaImpactoNegocio
    };
    return axios({
      url: baseurl + "Sistema/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaSistemasConsulta(currentPage, 10)
        setSuccess("Sistema cadastrado com sucesso!");
        setCadastroSistema({
          descricao: "",
          fornecedor: "",
          versao: "",
          nome: "",
          dataInicialVersao: "",
          dataFinalVersao: "",
        })
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const ListaSistemas = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Sistema/Listar?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setSistemas(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [totalRegistrosSistema, setTotalRegistrosSistema] = useState(0);

  const ListaSistemasConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: `${baseurl}Sistema/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const user = eval(response.data.data);
      const arrayArea = user.map((e) => ({
        nome: e.nome,
        descricao: e.descricao,
        fornecedor: e.fornecedor,
        versao: e.versao,
        dataInicialVersao: e.dataInicialVersao,
        dataFinalVersao: e.dataFinalVersao,
        key: e.key,
        id: e.id,
        idExterno: e.idExterno,
        camadaImpactoNegocio: e.camadaImpactoNegocio
      }));
      setSistemasConsulta(prevAreas => {
        const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
        return isEqual ? prevAreas : arrayArea;
      });
      setTotalRegistrosSistema(response.data.totalRegistros);
    } catch (error) {
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      return Promise.reject(error);
    }
  })

  const [filtroSistema, setFiltroSistema] = useState([]);
  const [totalRegistrosFiltroSistema, setTotalRegistrosFiltroSistema] = useState(0);

  const ListaFiltroSistema = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Sistema/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroSistema(response.data.data);
        setTotalRegistrosFiltroSistema(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const EditarSistema = async (currentPage) => {
    const token = Cookies.get("Token");
    setLoading(true)
    let dataInicialISO = '';
    let dataFinalISO = '';
    if (typeof EdicaoSistema.dataInicialVersao != "undefined" && EdicaoSistema.dataInicialVersao != "") {
      dataInicialISO = new Date(EdicaoSistema.dataInicialVersao).toISOString();
    }
    if (typeof EdicaoSistema.dataFinalVersao != "undefined" && EdicaoSistema.dataFinalVersao != "") {
      dataFinalISO = new Date(EdicaoSistema.dataFinalVersao).toISOString();
    }
    const data = {
      empresaKey: EmpresaKey,
      descricao: EdicaoSistema.descricao,
      nome: EdicaoSistema.nome,
      versao: EdicaoSistema.versao,
      dataInicialVersao: EdicaoSistema.dataInicialVersao,
      dataFinalVersao: EdicaoSistema.dataFinalVersao,
      fornecedorKey: EdicaoSistema.fornecedorKey,
      idExterno: EdicaoSistema.idExterno,
      camadaImpactoNegocio: EdicaoSistema.camadaImpactoNegocio
    };
    return axios({
      url: baseurl + "Sistema/Alterar?key=" + SistemaAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaSistemasConsulta(currentPage, 10);
        setSuccess("Sistema editado com sucesso!");
        setModalEditarSistema(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }

  const ExcluirSistema = async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "Sistema/Deletar?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaSistemasConsulta(currentPage, 10)
        setSuccess("Sistema excluído com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirSistema(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        console.log(error)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const [ImpactoNegocio, setImpactoNegocio] = useState([]);

  const ListarImpactoNegocio = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Sistema/ListarImpactoNegocio",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setImpactoNegocio(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const RetornaMatrizItem = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "MatrizTime/RetornaItem?empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setMatrizItem(response.data);
      })
      .catch((error) => {
        console.log(error)
        // if (error.response.status === 401) {
        //   setError(`Sua sessão expirou, faça login novamente`)
        //   setTimeout(() => {
        //     setError("");
        //   }, 3000);
        //   setAuth(false)
        //   return
        // }
        // error.response.data.map((er) => {
        //   setError(`${er.campo}: ${er.mensagem}`)
        // })
        return Promise.reject();
      });
  })

  const [AjusteMatriz, setAjusteMatriz] = useState([])

  const AjustarObterMatriz = useCallback(async (sistemaKey) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "MatrizTime/AjustarObter?empresaKey=" + EmpresaKey + "&sistemakey=" + sistemaKey + "&capacidadeDemandaKey=" + CapacidadeAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setAjusteMatriz(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [ArvoreCapacidadesMatriz, setArvoreCapacidadesMatriz] = useState([])

  const ListaCapacidadesMatriz = useCallback(async (ativo) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "MatrizTime/Arvore?empresaKey=" + `${EmpresaKey}` + "&somenteAtivas=" + ativo,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setArvoreCapacidadesMatriz(response.data);
      })
      .catch((error) => {
        setLoading(false)
        console.log(error)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [MatrizTime, setMatrizTime] = useState([])

  const SalvarMatriz = useCallback(async (event, avaliacoes, matrizTimeKey) => {
    setLoading(true)
    event.preventDefault();
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "MatrizTime/SalvarAvaliacao?matrizTimeKey=" + matrizTimeKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: avaliacoes
    })
      .then((response) => {
        setLoading(false)
        setMatrizTime(response.data);
        ListaCapacidadesMatriz()
        setSuccess("Matriz salva com sucesso!");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [ListaAvaliacaoMatriz, setListaAvaliacaoMatriz] = useState([])

  const ListarAvaliacaoMatriz = useCallback(async (matrizTimeKey) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "MatrizTime/ListarAvaliacao?matrizTimeKey=" + matrizTimeKey + "&empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setListaAvaliacaoMatriz(response.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [RelatorioMatriz, setRelatorioMatriz] = useState([])

  const ObterRelatorioMatriz = useCallback(async () => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "MatrizTime/Relatorio?capacidadeNegocioDemandaKey=" + CapacidadeAtualKey + "&empresaKey=" + EmpresaKey,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setRelatorioMatriz(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        return Promise.reject();
      });
  })

  const [GraficoMatrizTime, setGraficoMatrizTime] = useState([])

  const ObterGraficoMatrizTime = async () => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + `MatrizTime/Grafico?capacidadeNegocioDemandaKey=${CapacidadeAtualKey}&empresaKey=${EmpresaKey}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        if (response.data.length !== 0) {
          setGraficoMatrizTime(response.data)
        }
        else {
          setGraficoMatrizTime([])
          setTimeout(() => {
            setSuccess("");
          }, 3000);
        }

      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);

          setAuth(false)
          return
        }
        // error.response.data.map((er) => {
        //     setError(`${er.campo}: ${er.mensagem}`)
        // })
        // setTimeout(() => {
        //     setError("");
        // }, 3000);
        return Promise.reject();
      });
  }

  const [modalExcluirMatrizTime, setModalExcluirMatrizTime] = useState(false)

  const ExcluirMatriz = async (key) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "MatrizTime/Deletar?capacidadeNegocioDemandaKey=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaCapacidadesMatriz(true)
        setSuccess("Matriz excluída com sucesso!")
        setModalExcluirMatrizTime(false)
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        setModalExcluirMatrizTime(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const ExcluirMatrizIndividual = async (key) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "MatrizTime/DeletarMatriz?matrizTimeKey=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        setSuccess("Matriz excluída com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const [GraficoMatrizTimeSistema, setGraficoMatrizTimeSistema] = useState([])

  const ObterGraficoMatrizTimeSistema = async () => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + `MatrizTime/GraficoSistema?sistemaKey=${SistemaAtualKey}&empresaKey=${EmpresaKey}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.data.length !== 0) {
          setGraficoMatrizTimeSistema(response.data)
          setLoading(false)
        }
        else {
          setGraficoMatrizTimeSistema([])
          setTimeout(() => {
            setSuccess("");
          }, 3000);
        }

      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);

          setAuth(false)
          return
        }
        // error.response.data.map((er) => {
        //     setError(`${er.campo}: ${er.mensagem}`)
        // })
        // setTimeout(() => {
        //     setError("");
        // }, 3000);
        return Promise.reject();
      });
  }

  const [GraficoMatrizTimeSistemaCiclo, setGraficoMatrizTimeSistemaCiclo] = useState([])

  const ObterGraficoMatrizTimeSistemaCiclo = async (cicloKey) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + `MatrizTime/GraficoSistemaCiclo?cicloKey=${cicloKey}&empresaKey=${EmpresaKey}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.data.length !== 0) {
          setGraficoMatrizTimeSistemaCiclo(response.data)
          setLoading(false)
        }
        else {
          setGraficoMatrizTimeSistemaCiclo([])
          setTimeout(() => {
            setSuccess("");
          }, 3000);
        }

      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);

          setAuth(false)
          return
        }
        // error.response.data.map((er) => {
        //     setError(`${er.campo}: ${er.mensagem}`)
        // })
        // setTimeout(() => {
        //     setError("");
        // }, 3000);
        return Promise.reject();
      });
  }

  const [CadastroDominioMapaCalor, setCadastroDominioMapaCalor] = useState([])

  const CadastrarDominioMapaCalor = async (event, currentPage) => {
    setLoading(true)
    event.preventDefault();
    const token = Cookies.get("Token");
    if (CadastroDominioMapaCalor === "") {
      setLoading(false)
      setError("Formulário vazio.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    if (typeof CadastroDominioMapaCalor.descricao === "undefined" || CadastroDominioMapaCalor.descricao === "") {
      setLoading(false)
      setError("Nome não informado");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }
    const data = {
      empresaKey: EmpresaKey,
      descricao: CadastroDominioMapaCalor.descricao,
      ativo: true,
      idExterno: CadastroDominioMapaCalor.idExterno,
      corHexadecimal: CadastroDominioMapaCalor.corHexadecimal
    };
    return axios({
      url: baseurl + "DominioMapaCalor/Adicionar",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaDominioMapaCalorConsulta(currentPage, 10)
        setSuccess("Domínio do Mapa de Calor cadastrado com sucesso!");
        setCadastroDominioMapaCalor({
          descricao: "",
        })
        setOpenModal(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setError(error.response.data)
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error);
      });
  }

  const [DominioMapaCalor, setDominioMapaCalor] = useState([])

  const ListaDominioMapaCalor = useCallback(async () => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "DominioMapaCalor/Listar?empresaKey=" + EmpresaKey + "&somenteAtivas=S",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setDominioMapaCalor(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [DominioMapaCalorConsulta, setDominioMapaCalorConsulta] = useState([])
  const [totalRegistrosDominioMapaCalor, setTotalRegistrosDominioMapaCalor] = useState(0);

  const ListaDominioMapaCalorConsulta = useCallback(async (posicao, qtd) => {
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: `${baseurl}DominioMapaCalor/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&somenteAtivas=N`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      const user = eval(response.data.data);
      const arrayArea = user.map((e) => ({
        descricao: e.descricao,
        key: e.key,
        ativo: e.ativo,
        id: e.id,
        idExterno: e.idExterno,
        corHexadecimal: e.corHexadecimal
      }));
      setDominioMapaCalorConsulta(prevAreas => {
        const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
        return isEqual ? prevAreas : arrayArea;
      });
      setTotalRegistrosDominioMapaCalor(response.data.totalRegistros);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`)
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false)
        return
      }
      error.response.data.map((er) => {
        setError(`${er.campo}: ${er.mensagem}`)
      })
      setTimeout(() => {
        setError("");
      }, 3000);
      return Promise.reject(error);
    }
  });

  const [filtroDominioMapaCalor, setFiltroDominioMapaCalor] = useState([]);
  const [totalRegistrosFiltroDominioMapaCalor, setTotalRegistrosFiltroDominioMapaCalor] = useState(0);

  const ListaFiltroDominioMapaCalor = useCallback(async (filtro, posicao, quantidade) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "DominioMapaCalor/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroDominioMapaCalor(response.data.data);
        setTotalRegistrosFiltroDominioMapaCalor(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  });

  const [EdicaoDominioMapaCalor, setEdicaoDominioMapaCalor] = useState([])

  const [DominioMapaCalorAtualKey, setDominioMapaCalorAtualKey] = useState("")
  const [modalEditarDominioMapaCalor, setModalEditarDominioMapaCalor] = useState(false)
  const [modalExcluirDominioMapaCalor, setModalExcluirDominioMapaCalor] = useState(false)

  const EditarDominioMapaCalor = async (currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token");
    const data = {
      empresaKey: EmpresaKey,
      descricao: EdicaoDominioMapaCalor.descricao,
      ativo: EdicaoDominioMapaCalor.ativo,
      idExterno: EdicaoDominioMapaCalor.idExterno,
      empresaKey: EmpresaKey,
      corHexadecimal: EdicaoDominioMapaCalor.corHexadecimal
    };
    return axios({
      url: baseurl + "DominioMapaCalor/Alterar?key=" + DominioMapaCalorAtualKey,
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
      .then(() => {
        ListaDominioMapaCalorConsulta(currentPage, 10)
        setSuccess("Domínio do Mapa de Calor editado com sucesso!");
        setModalEditarDominioMapaCalor(false);
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        setLoading(false)
        return Promise.reject();
      });
  }

  const InativarDominioMapaCalor = async (key, status) => {
    setLoading(true)
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "DominioMapaCalor/Ativo?key=" + key + "&status=" + status,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setDominioMapaCalorConsulta(prev =>
          prev.map(item =>
            item.key === key ? { ...item, ativo: status } : item
          )
        );
        setSuccess("Domínio do Mapa de Calor ativado/inativado com sucesso!");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setLoading(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        setLoading(false)
        return Promise.reject();
      });
  }

  const ExcluirDominioMapaCalor = async (key, currentPage) => {
    setLoading(true)
    const token = Cookies.get("Token")
    return axios({
      url: baseurl + "DominioMapaCalor/Deletar?key=" + key,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false)
        ListaDominioMapaCalorConsulta(currentPage, 10)
        setSuccess("Domínio do Mapa de Calor excluído com sucesso!")
        setTimeout(() => {
          setSuccess("");
        }, 3000);
        setModalExcluirDominioMapaCalor(false)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setLoading(false);
          setAuth(false)
          return
        }
        setLoading(false)
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject(error)
      })
  }

  const ExportarDados = useCallback(async (recurso) => {
    const token = Cookies.get("Token");

    setLoading(true);

    return axios({
      url: baseurl + "Importacao/Exportar?recurso=" + recurso + "&empresaKey=" + EmpresaKey,
      method: "GET",
      responseType: 'arraybuffer',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false);

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); // 👈 xlsx

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const dataHoje = new Date().toISOString().slice(0, 10);
        link.setAttribute('download', `${recurso}_${dataHoje}.xlsx`); // 👈 .xlsx
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        return true;
      })
      .catch((error) => {
        setLoading(false)
        if (error?.response?.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return false
        }
        setError(mensagemErroArquivo(error, "Não foi possível exportar os dados. Tente novamente."));
        setTimeout(() => {
          setError("");
        }, 5000);
        return false;
      });
  })

  // A API responde List<ModelErrors> nos erros, mas nas rotas de download o
  // responseType é arraybuffer, então o corpo do erro chega binário e um
  // .map() direto quebra dentro do catch (o erro nunca chegava na tela).
  const mensagemErroArquivo = (error, fallback) => {
    let dados = error?.response?.data;

    if (dados instanceof ArrayBuffer) {
      try {
        dados = JSON.parse(new TextDecoder().decode(new Uint8Array(dados)));
      } catch (e) {
        dados = null;
      }
    }

    if (Array.isArray(dados)) {
      const mensagens = dados
        .map((er) => [er.campo, er.mensagem].filter(Boolean).join(": "))
        .filter(Boolean);
      if (mensagens.length) return mensagens.join(" | ");
    }

    if (typeof dados === "string" && dados.trim()) return dados;
    if (dados?.mensagem) return dados.mensagem;

    return fallback;
  };

  const ImportarDados = useCallback(async (recurso, arquivo) => {
    const token = Cookies.get("Token");
    const formData = new FormData();
    formData.append("arquivo", arquivo);

    setLoading(true);

    try {
      await axios({
        url: baseurl + "Importacao/Importar?recurso=" + recurso + "&empresaKey=" + EmpresaKey,
        method: "POST",
        data: formData,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setLoading(false);
      setSuccess("Arquivo importado com sucesso! Colocado na fila de processamento.");
      setTimeout(() => {
        setSuccess("");
      }, 5000);
      return true;
    } catch (error) {
      setLoading(false);

      if (error?.response?.status === 401) {
        setError(`Sua sessão expirou, faça login novamente`);
        setTimeout(() => {
          setError("");
        }, 3000);
        setAuth(false);
        return false;
      }

      setError(mensagemErroArquivo(error, "Não foi possível importar o arquivo. Tente novamente."));
      setTimeout(() => {
        setError("");
      }, 5000);
      return false;
    }
  })

  const [Log, setLog] = useState([])

  const ListaLog = useCallback(async (recurso) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Importacao/Listar?empresaKey=" + EmpresaKey + "&recurso=" + recurso,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        setLog(response.data);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`)
        })
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  })

  const [LogConsulta, setLogConsulta] = useState([])
  const [totalRegistrosLog, setTotalRegistrosLog] = useState(0);

  // silencioso: atualiza os dados sem acionar o loading (usado pelo polling do LOG)
  const ListaLogConsulta = useCallback(async (posicao, qtd, recurso, silencioso = false) => {
    if (!silencioso) setLoading(true)
    try {
      const token = Cookies.get("Token");
      const response = await axios({
        url: `${baseurl}Importacao/ListarConsulta?empresaKey=${EmpresaKey}&posicao=${posicao}&quantidade=${qtd}&recurso=${recurso}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!silencioso) setLoading(false);
      const user = response.data.data;
      const arrayArea = user.map((e) => ({
        usuarioCriacao: e.usuarioCriacao,
        dataHoraImportacao: e.dataHoraImportacao,
        dataHoraProcessamento: e.dataHoraProcessamento,
        recurso: e.recurso,
        nomeArquivo: e.nomeArquivo,
        statusGlobal: e.statusGlobal,
        id: e.id,
        key: e.key,
      }));
      setLogConsulta(prevAreas => {
        const isEqual = JSON.stringify(prevAreas) === JSON.stringify(arrayArea);
        return isEqual ? prevAreas : arrayArea;
      });
      setTotalRegistrosLog(response.data.totalRegistros);
    } catch (error) {
      if (!silencioso) setLoading(false);
      // if (error.response.status === 401) {
      //   setError(`Sua sessão expirou, faça login novamente`)
      //   setTimeout(() => {
      //     setError("");
      //   }, 3000);
      //   setAuth(false)
      //   return
      // }
      // error.response.data.map((er) => {
      //   setError(`${er.campo}: ${er.mensagem}`)
      // })
      // setTimeout(() => {
      //   setError("");
      // }, 3000);
      console.log(error)
      return Promise.reject(error);
    }
  }, []);

  const [filtroLog, setFiltroLog] = useState([]);
  const [totalRegistrosFiltroLog, setTotalRegistrosFiltroLog] = useState(0);

  const ListaFiltroLog = useCallback(async (filtro, posicao, quantidade, recurso) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Importacao/ListarComFiltro?empresaKey=" + EmpresaKey + "&filtro=" + filtro + "&recurso=" + recurso + "&posicao=" + posicao + "&quantidade=" + quantidade,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setFiltroLog(response.data.data);
        setTotalRegistrosFiltroLog(response.data.totalRegistros);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`);
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false);
          return;
        }
        error.response.data.map((er) => {
          setError(`${er.campo}: ${er.mensagem}`);
        });
        setTimeout(() => {
          setError("");
        }, 3000);
        return Promise.reject();
      });
  }, []);

  const [LogUsuario, setLogUsuario] = useState([])

  const GerarLog = useCallback(async (key) => {
    const token = Cookies.get("Token");
    return axios({
      url: baseurl + "Importacao/GerarLog?logImportacaoKey=" + key,
      method: "GET",
      responseType: "arraybuffer",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setLoading(false)
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); // 👈 xlsx

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const dataHoje = new Date().toISOString().slice(0, 10);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        setLoading(false)
        if (error?.response?.status === 401) {
          setError(`Sua sessão expirou, faça login novamente`)
          setTimeout(() => {
            setError("");
          }, 3000);
          setAuth(false)
          return
        }
        setError(mensagemErroArquivo(error, "Não foi possível gerar o LOG da importação."));
        setTimeout(() => {
          setError("");
        }, 5000);
        return Promise.reject();
      });
  })

  useEffect(() => {
    if (EmpresaKey) {
      RetornaPermissao()
    }
  }, [EmpresaKey])

  useEffect(() => {
    if (Auth) {
      setLoading(true)
      ListaEmpresas()
      getEmpresa()
      RetornaPermissao()
        .then(() => {
          getPermissao()
          setLoading(false)
        })
    }
  }, [Auth])

  let data = {
    EmpresaKey, SimularBSC, DemandasCiclo, setDemandasCiclo, CadastroCiclo, setCadastroCiclo, ListaCiclos, ListaDemandaCiclo, Ciclos, setCiclos, EditarCiclo, setEditarCiclo, EditarCiclos, modalEditarCiclo, setModalEditarCiclo, CicloAtualKey, setCicloAtualKey, CadastrarEmpresa, Cadastro, setCadastro, CadastrarUsuario, CadastroUsuario, setCadastroUsuario, ListaUsuarios, Usuarios, setUsuarios, StatusUsuario, ListaEmpresas, setEmpresas, setFormSelecionarCiclo, FormSelecionarCiclo, Empresas, ListaDashboard, Dashboard, setDashboard, DashboardDados, setDashboardDados, DashboardFases, setDashboardFases, DashboardLinhas, setDashboardLinhas, DashboardImpacto, setDashboardImpacto, ListaCapacidades, Capacidades, setCapacidades, ListaCategorizacao, Categorias, setCategorias, ListaFases, Fases, setFases, ListaLinhaAtendimento, Linhas, setLinhas, ListaSetorGerencia, Setores, setSetores, ListaTipoDemanda,
    Tipos, setTipos, ListaDemanda, Demandas, setDemandas, getEmpresa, Empresa, AdicionarItensDemanda, modalEditarOpen, setModalEditar, setKey, setDemandaAtual, DemandaAtual, EditarItensDemanda, AtualizarStatus, loading, setLoading, CriarDemanda, setForm, FormDemanda, setGut, Gut, ObterBSC, DiretrizEstrategica, setDiretrizEstrategica, Prioridades, ResumoPrioridades, setgutBSC, GutBSC,
    linhaAtendimento, setlinhaAtendimento, Error, Success, openModal, setOpenModal, EditarDemanda, EditarDemandaModal, setModalEditarDemanda, alterarGutBSC, AlterarGutBSC, setAlterarGutBSC, GutGravidade, setGutGravidade, GutUrgencia, setGutUrgencia, GutTendencia, setGutTendencia, BSC, setBSC, BSCFiltro, setBSCFiltro, DemandaAtualKey, setDemandaAtualKey, ExcluirDemanda, ExcluirDemandaModal, setModalExcluirDemanda, AdicionarComentario, AddComentarioModal, setAddComentarioModal, AddComentario, setAddComentario, ListaComentario, Comentario, setComentario, AdicionarLink, AddLink, setAddLink, ListaLink, Link, setLink, FiltroDemanda, setFiltroDemanda, DemandaDadoDash, ExcluirComentario, ExcluirLink, BSCDados, setBSCDados, SalvarBSC, staticKey, FormLink, setFormLink, FormComentario, setFormComentario, AdicionarDemandaCiclo, AdicionarLinha, EditarLinha, TrocarRoleModal, setModalTrocarRole, EditarRole, UserId, setIdUser, NomeUser, setNomeUser, EmailUser, setEmailUser, AdminUser, setAdminUser, SupervisorUser, setSupervisorUser, LeitorUser, setLeitorUser, FormRisco, setFormRisco, setError, AdicionarRisco, ListaRisco, ExcluirRisco, AddRisco, setAddRisco, Risco, setRisco, show, setShow, comentarioRef, linkRef, descricaoRef, riscoJustificativaRef, mitigacaoJustificativaRef, modalEnviarCiclo, setModalEnviarCiclo, arraySelecionarDemandaCiclo, setArraySelecionarDemandaCiclo, ExcluirCiclo, ExcluirCicloModal, setModalExcluirCiclo, Descricao, setDescricao, CenarioAtual, setCenarioAtual, ProblemaCenarioAtual, setProblemaCenarioAtual, Objetivo, setObjetivo, Resultado, setResultado, Necessidade, setNecessidade, Oportunidade, setOportunidade, DataLimite, setDataLimite, Esforco, setEsforco, ExcluirDemandaCiclo, ExcluirDemandaCicloModal, setExcluirDemandaCicloModal, demandaCicloAtual, setDemandaCicloAtual, AddDemandaCiclo, setAddDemandaCiclo, RTFModal, setRTFModal, ListaCicloDemanda, CicloDem, setCicloDem, CadastrarCiclo, ObterDemanda, Dem, setDem, CancelarDemanda, CancelarDemandaModal, setCancelarDemandaModal, MotivoCancelar, setMotivoCancelar, ConcluirDemanda, ConcluirDemandaModal, setConcluirDemandaModal, CompartilharDemanda, Compartilhar, setCompartilhar, CompartilharDemandaModal, setCompartilharDemandaModal, VerCompartilhada, DemCompartilhada, setDemCompartilhada, ListarCompartilhamentos, ListaDemCompartilhada, setListaDemCompartilhada, KeyCompartilhar, setKeyCompartilhar, UrlCompartilhar, setUrlCompartilhar, EditarRisco, RiscoEditar, setRiscoEditar, AdicionarCapacidade, EditarCapacidade, CriarSwot, Swot, setSwot, SwotItemSelecionado, setSwotItemSelecionado, ListaSwot, SwotLista, ExcluirSwot, SwotAtualKey, setSwotAtualKey, ForcaSwot, setForcaSwot, FraquezaSwot, setFraquezaSwot, OportunidadeSwot, setOportunidadeSwot, AmeacaSwot, setAmeacaSwot, ObterSwot, SwotObter, setSwotObter, SwotItemLista, setSwotItemLista, ListaSwotItem, AdicionarSwotItem, AddSwotItem, setAddSwotItem, ExcluirSwotItem, EditarSwot, SwotMatriz, setSwotMatriz, ListaMatriz, SwotRelatorio, setSwotRelatorio,
    ListaRelatorio, forcaItem, setForcaItem, fraquezaItem, setFraquezaItem, oportunidadeItem, setOportunidadeItem, ameacaItem, setAmeacaItem, ListaArvoreCapacidades, ArvoreCapacidades, setArvoreCapacidades, CriarCiclo, CicloCadastro, setCicloCadastro, modalCriarCiclo, setModalCriarCiclo, ListaSistemaCapacidade, SistemaCapacidade, setSistemaCapacidade, CapacidadeAtualKey, setCapacidadeAtualKey, CadastrarPlanoNegocio, PlanoNegocio, setPlanoNegocio, ListaPlanoNegocio, PlanoNegocios, setPlanoNegocios, ListaTipoPlanoNegocio, TipoPlanoNegocio, setTipoPlanoNegocio,
    ExcluirPlanoNegocio, EditarPlanoNegocio, EdicaoPlanoNegocio, setEdicaoPlanoNegocio, PlanoNegocioAtualKey, setPlanoNegocioAtualKey, modalEditarPlanoNegocio, setModalEditarPlanoNegocio, modalExcluirPlanoNegocio, setModalExcluirPlanoNegocio, StatusPlanoNegocio, CadastrarPlanoNegocioAvaliacao, PlanoNegocioAvaliacao, setPlanoNegocioAvaliacao, ListaPlanoNegocioAvaliacao, Avaliacao, ExcluirPlanoNegocioAvaliacao, PlanoNegocioAvaliacaoAtualKey, setPlanoNegocioAvaliacaoAtualKey, FormPlano, setFormPlano, PlanoDemanda, ListaPlanoDemanda, ExcluirPlanoDemanda, ObterDiretrizesItemsDoCiclo, DiretrizesItemsDoCiclo, stringDiretrizesItems, setStringDiretrizesItems, GutSwot, setGutSwot, ObterGutSwot, CapacidadeDemanda, ListaCapacidadeNegocio,
    ExcluirCapacidadeNegocio, AdicionarCapacidadeNegocio, Capacidade, setCapacidade, EdicaoCapacidade, setEdicaoCapacidade, ListaCapacidadesPorArea, CapacidadesPorArea, setCapacidadesPorArea, BSCs, setBSCs, ListaBSC, CadastrarBSC, CadastroBSC, setCadastroBSC, modalEditarBSC, setModalEditarBSC, BSCPadrao, ObterBSCPorCiclo, BSCPorCiclo, setBSCPorCiclo, DiretrizEstrategicaPorCiclo, setDiretrizEstrategicaPorCiclo, PrioridadesPorCiclo, setPrioridadesPorCiclo, ResumoPrioridadesPorCiclo, setResumoPrioridadesPorCiclo, AdicionarCompetenciaItem, CompetenciaDemanda, setCompetenciaDemanda, ExcluirCompetenciaItem, ListaCompetenciaItem, showModalArvoreDeCapacidades, setModalArvoreDeCapacidades, showModalCustoxdemanda, setModalCustoxdemanda, ListaSwotPorCiclo,
    SwotPorCiclo, ListaDemandaPorCiclo, DemandaPorCiclo, modalCriarDemanda, setModalCriarDemanda, ListaCapacidadePorAreaSwot, CapacidadePorAreaSwot, setCapacidadePorAreaSwot, delibComite, setDelibComite, ObterCicloValido, CicloValido, setCicloValido, AdicionarCruzamento, AddCruzamento, setAddCruzamento, ExcluirCruzamento, ListaCruzamento, Cruzamento, modalExcluirCruzamento, setModalExcluirCruzamento, cruzamentoKey, setCruzamentoKey, modalBSCPadrao, setModalBSCPadrao, AdicionarAnexo, AddFile, setAddFile, ExcluirAnexo, ListaAnexo, File, setFile, BaixarAnexo, FormAnexo, setFormAnexo, getPermissao, Permissao, AtualizarPlanoNegocio, totalGutSwot, setTotalGutSwot, CapacidadesConsulta, setCapacidadesConsulta, ListaCapacidadesConsulta,
    CategoriasConsulta, setCategoriasConsulta, ListaCategorizacaoConsulta, LinhasConsulta, ListaLinhaAtendimentoConsulta, PlanoNegociosConsulta, setPlanoNegociosConsulta, ListaPlanoNegocioConsulta, SetoresConsulta, ListaSetorGerenciaConsulta, TiposConsulta, ListaTipoDemandaConsulta, ListaUsuariosConsulta, UsuariosConsulta, ListaCiclosConsulta, CiclosConsulta, ListaSwotConsulta, SwotListaConsulta, ListaBSCConsulta, BSCsConsulta, CadastroArea, setCadastroArea, Areas, setAreas, CadastrarArea, ListaArea, EditarArea, EdicaoArea, setEdicaoArea, AreaAtualKey, setAreaAtualKey, modalEditarArea, setModalEditarArea, ExcluirArea, modalExcluirArea, setModalExcluirArea, ItensArea, setItensArea, AreaItens, setAreaItens, ListaItensArea, ExcluirItensArea, AdicionarItensArea, openModal, setOpenModal, ListaAreaPorCiclo, AreaPorCiclo, ListaAreaConsulta, AreasConsulta, setAreasConsulta, CadastroCargo, setCadastroCargo, Cargos, setCargos, CadastrarCargo, ListaCargo, EditarCargo, EdicaoCargo, setEdicaoCargo, CargoAtualKey, setCargoAtualKey, modalEditarCargo, setModalEditarCargo, ExcluirCargo, modalExcluirCargo, setModalExcluirCargo, CargosConsulta, ListaCargoConsulta, CadastroCompetencia, setCadastroCompetencia, Competencias, setCompetencias, CadastrarCompetencia, ListaCompetencia, EditarCompetencia, EdicaoCompetencia, setEdicaoCompetencia, CompetenciaAtualKey, setCompetenciaAtualKey, modalEditarCompetencia, setModalEditarCompetencia, ExcluirCompetencia, modalExcluirCompetencia, setModalExcluirCompetencia, CompetenciasConsulta, setCompetenciasConsulta, ListaCompetenciaConsulta, CadastroPessoa, setCadastroPessoa, Pessoas, setPessoas, CadastrarPessoa, ListaPessoa, EditarPessoa, EdicaoPessoa, setEdicaoPessoa, PessoaAtualKey, setPessoaAtualKey, modalEditarPessoa, setModalEditarPessoa, ExcluirPessoa, modalExcluirPessoa, setModalExcluirPessoa, PessoasPorCargo, setPessoasPorCargo, ListaPessoaPorCargo, PessoasConsulta, ListaPessoaConsulta, CadastroSistema, setCadastroSistema, Sistemas, setSistemas, CadastrarSistema, ListaSistemas,
    EditarSistema, EdicaoSistema, setEdicaoSistema, SistemaAtualKey, setSistemaAtualKey, modalEditarSistema, setModalEditarSistema, ExcluirSistema, modalExcluirSistema, setModalExcluirSistema, SistemasConsulta, ListaSistemasConsulta, AdicionarServicoCapacidade, ListaServicoCapacidade, ExcluirServicoCapacidade, CapacidadeServico, setCapacidadeServico, RetornaSistemaCapacidade, CapacidadeSistema, RetornaSistemaServico, SistemaServico, ListaAreaUsuario, AreaUsuario, EdicaoUsuario, setEdicaoUsuario, CompetenciaCargo, setCompetenciaCargo, AdicionarCargoCompetencia, ListaCargoCompetencia, ExcluirCargoCompetencia, InativarCompetencia, LinhaAtualKey, setLinhaAtualKey, CadastroLinha, setCadastroLinha, ListaAreaLinha, LinhaArea, EdicaoLinha, setEdicaoLinha, ItensLinha, setItensLinha, ListaLinhaPessoas, AdicionarLinhaPessoa, ExcluirLinhaPessoa, AreaTimes, setAreaTimes, RetornaAreaTimes, TimeObter, setTimeObter, ObterTimes, CriarSwotServico, SwotServico, setSwotServico, SwotServicoItem, setSwotServicoItem, ListaSwotServico, SwotServicoLista, ExcluirSwotServico, SwotServicoAtualKey, setSwotServicoAtualKey, ForcaSwotServico, setForcaSwotServico, FraquezaSwotServico, setFraquezaSwotServico, OportunidadeSwotServico, setOportunidadeSwotServico, AmeacaSwotServico, setAmeacaSwotServico, ObterSwotServico, SwotServicoObter, setSwotServicoObter, SwotServicoItemLista, setSwotServicoItemLista, ListaSwotServicoItem, AdicionarSwotServicoItem, AddSwotServicoItem, setAddSwotServicoItem, ExcluirSwotServicoItem, EditarSwotServico, SwotServicoMatriz, setSwotServicoMatriz, ListaMatrizServico, SwotServicoRelatorio, setSwotServicoRelatorio, ListaRelatorioServico, forcaServicoItem, setForcaServicoItem, fraquezaServicoItem, setFraquezaServicoItem, oportunidadeServicoItem, setOportunidadeServicoItem, ameacaServicoItem, setAmeacaServicoItem, SwotServicoPorCiclo, setSwotServicoPorCiclo, ListaServicoPorArea, ServicosPorArea, setServicosPorArea, ListaAreaSwotServico, AreaSwotServico, ListaSwotServicoConsulta, SwotServicoListaConsulta, AdicionarCruzamentoServico, AddCruzamentoServico, setAddCruzamentoServico, ExcluirCruzamentoServico, ListaCruzamentoServico, CruzamentoServico, cruzamentoServicoKey, setCruzamentoServicoKey, ListaAreaSwot, AreaSwot, ListaAreaDemanda, AreaDemanda, ListaAreaCapacidade, AreaCapacidade, AlterarPlanoNegocioAvaliacao, EdicaoAvaliacao, setEdicaoAvaliacao, modalEditarAvaliacao, setModalEditarAvaliacao, AvaliacaoAtualKey, setAvaliacaoAtualKey, modalExcluirAvaliacao, setModalExcluirAvaliacao, RetornaMatrizItem, MatrizItem, AjustarObterMatriz, AjusteMatriz, SalvarMatriz, MatrizTime, setMatrizTime, ListarAvaliacaoMatriz, ListaAvaliacaoMatriz, ObterRelatorioMatriz, RelatorioMatriz, ObterGraficoMatrizTime, GraficoMatrizTime, ListaCapacidadesMatriz, ArvoreCapacidadesMatriz, ExcluirMatriz, modalExcluirMatrizTime, setModalExcluirMatrizTime, ExcluirMatrizIndividual, ObterGraficoMatrizTimeSistema, GraficoMatrizTimeSistema, ObterMapaCalor,
    MapaCalor, RetornaTipoCapacidade, TipoCapacidade, ObterCapacidade, CapacidadeObter, setCapacidadeObter,
    filtroArea, ListaFiltroArea, totalRegistrosFiltroArea, totalRegistrosArea,
    filtroCapacidade, ListaFiltroCapacidade, totalRegistrosFiltroCapacidade, totalRegistrosCapacidade,
    filtroCargo, ListaFiltroCargo, totalRegistrosFiltroCargo, totalRegistrosCargo,
    filtroCategorizacao, ListaFiltroCategorizacao, totalRegistrosFiltroCategorizacao, totalRegistrosCategorizacao,
    filtroCiclo, ListaFiltroCiclo, totalRegistrosFiltroCiclo, totalRegistrosCiclo,
    filtroCompetencia, ListaFiltroCompetencia, totalRegistrosFiltroCompetencia, totalRegistrosCompetencia,
    filtroLinhaAtendimento, ListaFiltroLinhaAtendimento, totalRegistrosFiltroLinhaAtendimento, totalRegistrosLinhaAtendimento,
    filtroPessoa, ListaFiltroPessoa, totalRegistrosFiltroPessoa, totalRegistrosPessoa,
    filtroPlanoNegocio, ListaFiltroPlanoNegocio, totalRegistrosFiltroPlanoNegocio, totalRegistrosPlanoNegocio,
    filtroSetorGerencia, ListaFiltroSetorGerencia, totalRegistrosFiltroSetorGerencia, totalRegistrosSetorGerencia,
    filtroSistema, ListaFiltroSistema, totalRegistrosFiltroSistema, totalRegistrosSistema,
    filtroSwot, ListaFiltroSwot, totalRegistrosFiltroSwot, totalRegistrosSwot,
    filtroSwotServico, ListaFiltroSwotServico, totalRegistrosFiltroSwotServico, totalRegistrosSwotServico,
    filtroTipoDemanda, ListaFiltroTipoDemanda, totalRegistrosFiltroTipoDemanda, totalRegistrosTipoDemanda,
    filtroUsuario, ListaFiltroUsuario, totalRegistrosFiltroUsuario, totalRegistrosUsuario,
    filtroAvaliacao, ListaFiltroAvaliacao, totalRegistrosFiltroAvaliacao, totalRegistrosAvaliacao,
    filtroBSC, ListaFiltroBSC, totalRegistrosFiltroBSC, totalRegistrosBSC,
    AvaliacaoConsulta, ListaAvaliacaoConsulta, InativarAvaliacao, AvaliacaoCadastro, setAvaliacaoCadastro, CadastrarAvaliacao,
    AvaliacaoEdicao, setAvaliacaoEdicao, EditarAvaliacao, AvaliacaoAtualKey, setAvaliacaoAtualKey, modalEditarAvaliacao, setModalEditarAvaliacao, ExcluirAvaliacao, ExcluirCapacidade, modalExcluirCapacidade, setModalExcluirCapacidade, ConfirmarExcluirCapacidade,
    CadastroDominioMapaCalor, setCadastroDominioMapaCalor, CadastrarDominioMapaCalor, EdicaoDominioMapaCalor, setEdicaoDominioMapaCalor, EditarDominioMapaCalor, ExcluirDominioMapaCalor,
    ListaDominioMapaCalor, ListaDominioMapaCalorConsulta, DominioMapaCalor, DominioMapaCalorConsulta,
    filtroDominioMapaCalor, ListaFiltroDominioMapaCalor, totalRegistrosDominioMapaCalor, totalRegistrosFiltroDominioMapaCalor, DominioMapaCalorAtualKey, setDominioMapaCalorAtualKey, modalEditarDominioMapaCalor, setModalEditarDominioMapaCalor, modalExcluirDominioMapaCalor, setModalExcluirDominioMapaCalor, InativarDominioMapaCalor, ListaAreaUsuarioMapaCalor, AreaUsuarioMapaCalor, ObterGraficoMatrizTimeSistemaCiclo, GraficoMatrizTimeSistemaCiclo, RetornaMapaCalor, Visao, setVisao, ObterSwotPorCapacidade, SwotMapaCalor, setSwotMapaCalor, AdicionarSwotPeloMapaCalor, ListarImpactoNegocio, ImpactoNegocio, setImpactoNegocio, ListaSwotTiPorCiclo, SwotTiPorCiclo, setSwotTiPorCiclo, ListaRelatorioSwotTi, SwotTiRelatorio, ListaMatrizTi, SwotMatrizTi, ExportarDados, ImportarDados, ListaLog, Log, ListaLogConsulta, LogConsulta, ListaFiltroLog, filtroLog, totalRegistrosFiltroLog, GerarLog, LogUsuario
  };

  return <ApiContext.Provider value={data}>{children}</ApiContext.Provider>;
};
